/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import PropTypes from 'prop-types';

const AboutUsFirst = ({ width, height }) => {
  return (
    <svg
      id="freepik_stories-team-work"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 750 500"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      css={css`
        max-width: ${width || '100%'};
        max-height: ${height || '100%'};
        height: ${height || '100%'};
        width: ${width || '100%'};
        display: inline-block;
      `}
    >
      <style
        dangerouslySetInnerHTML={{
          __html:
            'svg#freepik_stories-team-work:not(.animated) .animable {opacity: 0;}svg#freepik_stories-team-work.animated #freepik--background-complete--inject-66 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-team-work.animated #freepik--Flag--inject-66 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}svg#freepik_stories-team-work.animated #freepik--Characters--inject-66 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-team-work.animated #freepik--Stairs--inject-66 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}svg#freepik_stories-team-work.animated #freepik--Plant--inject-66 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-team-work.animated #freepik--Floor--inject-66 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}            @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes zoomIn {                0% {                    opacity: 0;                    transform: scale(0.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes zoomOut {                0% {                    opacity: 0;                    transform: scale(1.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes fadeIn {                0% {                    opacity: 0;                }                100% {                    opacity: 1;                }            }        ',
        }}
      />
      <g
        id="freepik--background-complete--inject-66"
        style={{ transformOrigin: '348.72146797180176px 261.2094192504883px' }}
        className="animable"
      >
        <path
          d="M559.35,88.17c.59-4.28-5.45-7.8-10-8.16-2.16-.18-4.41.15-6.45-.56-4.44-1.55-6.22-7.29-10.55-9.11-3.24-1.37-7-.15-10.11,1.43s-6.24,3.57-9.75,3.79c-3.05.2-6.37-.93-9,.56-2,1.11-3,3.4-4.86,4.75s-4.13,1.61-6.36,1.73-4.53.14-6.56,1.07-3.7,3.07-3.28,5.26Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '520.8774681091309px 79.33799171447754px',
          }}
          id="eliq4nvy73s8"
          className="animable"
        />
        <path
          d="M98.79,140.89c.59-4.28-5.45-7.8-10-8.17-2.17-.17-4.41.16-6.46-.55-4.44-1.55-6.22-7.29-10.55-9.11-3.24-1.37-7-.15-10.11,1.43s-6.24,3.57-9.75,3.79c-3,.19-6.36-.94-9,.55-2,1.11-3,3.41-4.87,4.76s-4.13,1.6-6.36,1.72-4.53.15-6.56,1.08-3.7,3.07-3.28,5.26Z"
          style={{
            fill: 'rgb(245, 245, 245)',
            transformOrigin: '60.30747413635254px 132.0579891204834px',
          }}
          id="ellk6dj0gcy"
          className="animable"
        />
        <path
          d="M675.6,125c.86-6.25-8-11.4-14.6-11.93-3.16-.26-6.45.23-9.45-.82-6.49-2.26-9.08-10.65-15.42-13.32-4.74-2-10.19-.22-14.78,2.09s-9.13,5.22-14.26,5.55c-4.46.28-9.31-1.37-13.21.81-2.91,1.62-4.44,5-7.12,7s-6,2.35-9.3,2.52-6.62.21-9.59,1.57-5.41,4.49-4.8,7.69Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '619.316951751709px 112.11134433746338px',
          }}
          id="ellvvlvdm15je"
          className="animable"
        />
        <path
          d="M404.09,66c.64-4.63-5.9-8.45-10.82-8.84-2.34-.19-4.77.17-7-.61-4.81-1.67-6.73-7.89-11.43-9.87-3.51-1.48-7.55-.16-11,1.55s-6.76,3.87-10.56,4.11c-3.3.21-6.89-1-9.79.6-2.15,1.21-3.28,3.69-5.27,5.16s-4.47,1.73-6.89,1.86-4.9.16-7.1,1.16-4,3.33-3.55,5.7Z"
          style={{
            fill: 'rgb(245, 245, 245)',
            transformOrigin: '362.37204360961914px 56.42941188812256px',
          }}
          id="el2rlrvfstaff"
          className="animable"
        />
        <path
          d="M393.54,141.19c1.37.12,1.14,1.28,2.33,1.71a22.87,22.87,0,0,0,2.79.35l1.49.21,3-18.79a2.86,2.86,0,0,0-2.38-3.27l-18.38-3,.2-1.24a3.74,3.74,0,0,1,.67-1.59,7.68,7.68,0,0,0,1.39-4.5,7.92,7.92,0,0,0-5.67-7.32c-7.87-2.48-9,1.7-9.73,6.19a7.61,7.61,0,0,0,.15,3.16,3.88,3.88,0,0,1,.1,1.59l-.26,1.59-17.92-2.89a2.86,2.86,0,0,0-3.29,2.36l-8,49.53A2.34,2.34,0,0,0,342,168l50.49,8.14a2.34,2.34,0,0,0,2.68-1.92l2.89-17.91L396,156a10.58,10.58,0,0,0-1.21-.16c-1,0-2.14.47-3.15.3a7.71,7.71,0,0,1-6.36-9.14A7.47,7.47,0,0,1,393.54,141.19Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '371.5900249481201px 139.58998107910156px',
          }}
          id="ellztgv5oa0e"
          className="animable"
        />
        <path
          d="M389.57,140.68a7.25,7.25,0,0,1,3.52,1.39,4.26,4.26,0,0,0,1.6.67l1.48.21,3-18.79a2.87,2.87,0,0,0-2.38-3.28l-18.37-3,.2-1.23a3.68,3.68,0,0,1,.67-1.59,7.75,7.75,0,1,0-13.86-2.47,3.72,3.72,0,0,1,.09,1.59l-.25,1.58-17.92-2.89a2.87,2.87,0,0,0-3.29,2.36l-8,49.54a2.33,2.33,0,0,0,1.94,2.67l50.49,8.13a2.33,2.33,0,0,0,2.68-1.92l2.88-17.9-2-.33a3.77,3.77,0,0,0-1.42,0,7.82,7.82,0,0,1-2.94.09,7.72,7.72,0,0,1-6.37-9.14A7.47,7.47,0,0,1,389.57,140.68Z"
          style={{
            fill: 'rgb(245, 245, 245)',
            transformOrigin: '367.61805725097656px 139.24199295043945px',
          }}
          id="el59c7p2x67ys"
          className="animable"
        />
        <path
          d="M587,247.45l2.65,18a2.87,2.87,0,0,0,3.26,2.42l49.94-7.37a2.34,2.34,0,0,0,2-2.66l-7.47-50.6a2.34,2.34,0,0,0-2.65-2l-18.05,2.67.3,2a3.53,3.53,0,0,0,.48,1.34,7.87,7.87,0,0,1,1,2.78A7.75,7.75,0,1,1,603.33,213a3.78,3.78,0,0,0,.13-1.67l-.21-1.43-18.48,2.72a2.87,2.87,0,0,0-2.42,3.26l2.71,18.41Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '613.5969047546387px 236.558931350708px',
          }}
          id="elbnms488r2wr"
          className="animable"
        />
        <path
          d="M597.76,217.66a7.79,7.79,0,0,1,.15-3.88,3.93,3.93,0,0,0,.14-1.67l-.22-1.44-18.48,2.73a2.87,2.87,0,0,0-2.42,3.26l2.72,18.41-1.25.19a3.91,3.91,0,0,1-1.73-.16,7.75,7.75,0,1,0,1.82,14,3.92,3.92,0,0,1,1.5-.57l1.6-.24,2.65,18a2.88,2.88,0,0,0,3.26,2.42l49.94-7.37a2.34,2.34,0,0,0,2-2.66L631.94,208a2.33,2.33,0,0,0-2.65-2l-18,2.67.3,2a3.71,3.71,0,0,0,.48,1.34,7.74,7.74,0,0,1-5.87,11.61A7.81,7.81,0,0,1,597.76,217.66Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '603.0613250732422px 237.35751914978027px',
          }}
          id="eldooaagcbksm"
          className="animable"
        />
        <path
          d="M482.24,178.12l8.08,11.27a2.2,2.2,0,0,0,3.06.5l31.33-22.48a1.79,1.79,0,0,0,.41-2.49l-22.77-31.74a1.78,1.78,0,0,0-2.49-.41l-11.33,8.12.92,1.28a3,3,0,0,0,.8.75,5.67,5.67,0,0,1,1.63,1.54A5.92,5.92,0,1,1,481.26,149a3,3,0,0,0-.49-1.19l-.65-.9-11.6,8.32a2.19,2.19,0,0,0-.5,3.06l8.29,11.55Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '496.52943992614746px 161.3667278289795px',
          }}
          id="el63c92xm9y0b"
          className="animable"
        />
        <path
          d="M479.12,154.13a5.94,5.94,0,0,1-1.26-2.69,3,3,0,0,0-.49-1.18l-.65-.9-11.6,8.32a2.2,2.2,0,0,0-.5,3.06l8.29,11.55-.78.56a2.94,2.94,0,0,1-1.23.5A5.92,5.92,0,1,0,475.38,184a6,6,0,0,0,1.64-1.8,2.86,2.86,0,0,1,.82-.91l1-.72,8.08,11.26a2.2,2.2,0,0,0,3.06.51l31.33-22.48a1.78,1.78,0,0,0,.41-2.49L499,135.61a1.79,1.79,0,0,0-2.49-.41l-11.33,8.13.93,1.28a2.82,2.82,0,0,0,.79.75,5.67,5.67,0,0,1,1.63,1.54,5.92,5.92,0,0,1-9.36,7.23Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '493.1332607269287px 163.80695152282715px',
          }}
          id="elvumhwv93gt"
          className="animable"
        />
        <path
          d="M33.88,369.23s-6.24,2.53.95,15.76,12.11,19.75,12.11,19.75,1.29,3.08-1.32,3.63-8.4-.22-9.49,3,1.38,6.43,6.35,9.06,15.64,8.78,16.61,9.34,1.91,2,.2,2.63-14.66,2.35-13.49,8.45S62,452,63.65,452.58s2,1.26,1.93,2.15-4.52,1-8.18,1.68-7.8,2-6.83,5.47,10,10.55,31.49,12.09l10,.07,5.22-8.59c10.06-19.06,8.82-30.46,6.39-33.12s-5.77.13-8.25,2.91-4.93,6.43-5.75,6.05-1.17-1.08-.8-2.78,4-17.13-.51-21.35-12.83,5.88-14.3,7-2.16-.47-2.13-1.57.46-13.42.86-19-.89-9.35-4.33-10.17-5.73,4.53-7.58,6.45-3.78-.8-3.78-.8-2.93-7.62-10.36-20.72-13-9-13-9"
          style={{
            fill: 'rgb(245, 245, 245)',
            transformOrigin: '68.36932945251465px 421.3911666870117px',
          }}
          id="elbus80m2s077"
          className="animable"
        />
        <path
          d="M92.64,476.38c-5.42-9.65-14.76-26.95-22.86-41.76S54.35,406.42,49,396.75c-2.68-4.83-4.86-8.73-6.37-11.45l-1.73-3.11-.44-.81c-.1-.19-.14-.29-.14-.29s.06.09.16.27l.47.8,1.79,3.08c1.54,2.68,3.74,6.58,6.45,11.4,5.42,9.64,12.79,23,20.89,37.83s17.4,32.13,22.77,41.8"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '66.58500480651855px 428.73500061035156px',
          }}
          id="elq0m7evzjy7l"
          className="animable"
        />
        <path
          d="M44.2,412.8a2.67,2.67,0,0,1,.7.17c.45.13,1.09.34,1.87.6,1.58.54,3.74,1.33,6.1,2.24l6.05,2.37,1.83.7a3.71,3.71,0,0,1,.67.29,3.18,3.18,0,0,1-.71-.17c-.44-.14-1.08-.34-1.87-.62-1.57-.54-3.72-1.36-6.08-2.28l-6.06-2.32-1.84-.69A3.36,3.36,0,0,1,44.2,412.8Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '52.80999755859375px 415.9849853515625px',
          }}
          id="el261idpzguiy"
          className="animable"
        />
        <path
          d="M62.08,418.51c-.08,0,1.35-4.55,3.2-10.09s3.42-10,3.5-10-1.35,4.55-3.2,10.1S62.16,418.54,62.08,418.51Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '65.42999935150146px 408.4650869369507px',
          }}
          id="elr6n27p4ij1e"
          className="animable"
        />
        <path
          d="M73.49,441.81a3.38,3.38,0,0,1,.39-.63L75,439.53c1-1.39,2.29-3.33,3.67-5.51s2.56-4.2,3.41-5.67l1-1.74a3.27,3.27,0,0,1,.4-.62,2.85,2.85,0,0,1-.29.67c-.21.43-.52,1-.92,1.79-.8,1.5-2,3.55-3.34,5.74s-2.74,4.11-3.75,5.47c-.51.68-.92,1.23-1.22,1.6S73.51,441.83,73.49,441.81Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '78.48501205444336px 433.9006772041321px',
          }}
          id="elqnb7g6wf25"
          className="animable"
        />
        <path
          d="M56.17,440.2a3.11,3.11,0,0,1,.69,0l1.85.1c1.57.09,3.73.25,6.11.44s4.54.38,6.1.53l1.85.2a2.16,2.16,0,0,1,.67.12,3,3,0,0,1-.68,0l-1.86-.1c-1.56-.09-3.72-.25-6.1-.44s-4.55-.38-6.11-.53l-1.84-.2A3.32,3.32,0,0,1,56.17,440.2Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '64.80499267578125px 440.89511489868164px',
          }}
          id="el2qarxd65a9v"
          className="animable"
        />
        <path
          d="M63.63,462.05a4.54,4.54,0,0,1,.88,0l2.37.11c2,.12,4.78.29,7.84.51s5.82.43,7.82.6l2.37.21a5.38,5.38,0,0,1,.87.12,4,4,0,0,1-.88,0l-2.37-.11c-2-.12-4.78-.3-7.84-.51s-5.82-.43-7.82-.6l-2.37-.21A3.77,3.77,0,0,1,63.63,462.05Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '74.70500373840332px 462.8264446258545px',
          }}
          id="elcrrct63bpu"
          className="animable"
        />
        <path
          d="M85.26,463.43a5.21,5.21,0,0,1,.47-.81c.36-.55.82-1.28,1.38-2.15,1.15-1.81,2.74-4.32,4.42-7.14s3.13-5.41,4.17-7.29l1.23-2.23a6.67,6.67,0,0,1,.49-.81,5.44,5.44,0,0,1-.38.86c-.26.55-.65,1.32-1.15,2.28-1,1.91-2.41,4.52-4.09,7.35s-3.3,5.32-4.51,7.1c-.61.89-1.1,1.61-1.46,2.1A5.14,5.14,0,0,1,85.26,463.43Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '91.34000396728516px 453.2149963378906px',
          }}
          id="elgcemu9cyzju"
          className="animable"
        />
        <path
          d="M604,474.28c-13.13-6.59-18.09-21.66-19.63-35.62-.26-2.33-.87-4.74-.06-6.94s3.18-4,5.4-3.28c1.84.56,2.88,2.45,4.08,4a13.7,13.7,0,0,0,6.2,4.41c1.59.55,3.48.75,4.82-.27,1.84-1.39,1.68-4.19,1.33-6.49q-1-6.45-2-12.89a21.69,21.69,0,0,1-.3-6.95,7.24,7.24,0,0,1,3.8-5.5c2.1-.93,5-.06,5.79,2.13a22.62,22.62,0,0,1,.49,2.87,2.44,2.44,0,0,0,1.75,2.07c1,.14,1.79-.65,2.38-1.42a31.17,31.17,0,0,0,4.3-9.12,42.2,42.2,0,0,1,3.89-9.32c1.79-2.86,4.48-5.31,7.76-6s7.09.86,8.4,4-.11,6.71-1.79,9.64a52.27,52.27,0,0,1-9.24,11.78,4.24,4.24,0,0,0-1.51,2.19c-.28,1.61,1.4,2.92,3,3.21,1.81.32,3.64-.13,5.47-.18s3.9.46,4.83,2.06c1.28,2.22-.33,5-2,6.88a44.49,44.49,0,0,1-12,9.44,14.88,14.88,0,0,0-4.5,3.06c-1.2,1.39-1.72,3.58-.66,5.09s3.26,1.72,5,1.13a31.62,31.62,0,0,0,4.78-2.67c3-1.66,7.12-2,9.55.41a7.38,7.38,0,0,1,1.72,6.34,17.15,17.15,0,0,1-2.67,6.21,44.85,44.85,0,0,1-17,16.07c-7,3.61-13.7,5.29-21.39,3.68"
          style={{
            fill: 'rgb(245, 245, 245)',
            transformOrigin: '614.5481967926025px 430.3553161621094px',
          }}
          id="eltmzwo8d0i9"
          className="animable"
        />
        <path
          d="M606.28,465.05a206.63,206.63,0,0,1,5-23.45q.82-3.08,1.62-6.08c.53-2,1.07-4,1.71-5.87a104.52,104.52,0,0,1,4.29-10.72c1.54-3.34,3.11-6.46,4.61-9.36s2.95-5.58,4.38-8a83.25,83.25,0,0,1,7.56-10.74c1-1.19,1.78-2.09,2.33-2.7.27-.28.48-.51.63-.68s.22-.23.23-.22a2.75,2.75,0,0,1-.2.25c-.14.18-.34.41-.59.71-.53.62-1.3,1.54-2.27,2.75a86.46,86.46,0,0,0-7.43,10.79c-1.41,2.39-2.84,5.07-4.33,8s-3,6-4.56,9.37A104.85,104.85,0,0,0,615,429.79c-.63,1.89-1.15,3.85-1.69,5.85s-1.07,4-1.62,6.08a213.75,213.75,0,0,0-5,23.39"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '622.4600219726562px 426.16946029663086px',
          }}
          id="el4jhlikvbsfd"
          className="animable"
        />
        <path
          d="M614.69,429.62a6.24,6.24,0,0,1-.36-1c-.22-.62-.5-1.52-.83-2.65-.66-2.25-1.46-5.39-2.34-8.85s-1.72-6.58-2.41-8.81c-.35-1.12-.63-2-.84-2.64a4.45,4.45,0,0,1-.27-1,4.47,4.47,0,0,1,.43.93c.25.6.58,1.49,1,2.6.76,2.22,1.66,5.34,2.54,8.81s1.63,6.51,2.22,8.87c.27,1.07.5,2,.69,2.69A4.17,4.17,0,0,1,614.69,429.62Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '611.1649780273438px 417.1449890136719px',
          }}
          id="el7r362yjicph"
          className="animable"
        />
        <path
          d="M643.55,419.76a6.83,6.83,0,0,1-1.16.32c-.75.17-1.84.43-3.18.78-2.67.69-6.33,1.77-10.32,3.14s-7.54,2.77-10.08,3.86c-1.27.53-2.29,1-3,1.3a7.24,7.24,0,0,1-1.12.46,6.59,6.59,0,0,1,1-.61c.68-.36,1.69-.86,3-1.44,2.52-1.16,6.07-2.6,10.06-4a105.76,105.76,0,0,1,10.39-3c1.35-.31,2.45-.52,3.21-.65A6.9,6.9,0,0,1,643.55,419.76Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '629.1199645996094px 424.6899871826172px',
          }}
          id="elxbm3y1khdb"
          className="animable"
        />
        <path
          d="M606.56,464.45a1.3,1.3,0,0,1-.25-.33l-.67-1c-.57-.87-1.36-2.15-2.32-3.75-1.93-3.19-4.45-7.68-7.16-12.67s-5.19-9.5-7-12.72l-2.21-3.82c-.23-.42-.43-.76-.59-1s-.2-.37-.18-.38a1.61,1.61,0,0,1,.25.33l.66,1c.58.87,1.37,2.15,2.33,3.75,1.93,3.19,4.45,7.68,7.16,12.67s5.19,9.5,7.05,12.73c.9,1.57,1.65,2.85,2.2,3.81l.6,1C606.51,464.31,606.58,464.44,606.56,464.45Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '596.3693437576294px 446.61500549316406px',
          }}
          id="elotpm9nst17"
          className="animable"
        />
        <path
          d="M644.13,446s-.12.09-.37.22l-1.09.55-4,2c-3.39,1.68-8.06,4-13.21,6.66s-9.84,4.95-13.27,6.55c-1.71.8-3.11,1.44-4.08,1.86l-1.12.47c-.26.11-.4.16-.41.14a1.93,1.93,0,0,1,.37-.22l1.09-.55,4-2c3.4-1.67,8.06-4,13.21-6.66s9.84-4.94,13.27-6.55c1.72-.8,3.11-1.43,4.08-1.85l1.13-.48A2.17,2.17,0,0,1,644.13,446Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '625.35498046875px 455.2271308898926px',
          }}
          id="el7p9z3zahysl"
          className="animable"
        />
      </g>
      <g
        id="freepik--Flag--inject-66"
        style={{ transformOrigin: '158.45998764038086px 156.7899932861328px' }}
        className="animable"
      >
        <path
          d="M198.54,58.07s-11.93-4.29-19.93-1.76-10.26,7.6-16.36,7.34c-4.82-.21-8.28-2.2-10.14-7.26S150.06,45,133.67,46c-12.54.81-13.75,2.68-13.75,2.68l-.43,33.43c7.07-1.32,14.31-2.33,22.13-1.44a9.35,9.35,0,0,1,7.54,7.81c1.1,7.11,8.51,9.69,12.9,9.57,6.29-.18,9.36-4.51,14.65-5.89,8.31-2.15,22.86,3.31,22.86,3.31Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '159.52998733520508px 71.97437286376953px',
          }}
          id="el2xu2djjirwt"
          className="animable"
        />
        <path
          d="M154.13,85c.13,0,.19-5.54.13-12.38s-.2-12.37-.33-12.37-.19,5.54-.13,12.38S154,85,154.13,85Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '154.03000885248184px 72.62500190734863px',
          }}
          id="elejmw8xgulc5"
          className="animable"
        />
        <path
          d="M167,70.2c-.13,0-.08,5.73.11,12.78s.46,12.76.59,12.76.07-5.72-.12-12.78S167.07,70.2,167,70.2Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '167.34844267368317px 82.96999740600586px',
          }}
          id="elxymk8sgcqqg"
          className="animable"
        />
        <g id="elgc19vt2d3qa">
          <g
            style={{
              opacity: '0.2',
              transformOrigin: '160.48989725112915px 79.36505508422852px',
            }}
            className="animable"
          >
            <path
              d="M167.49,90.08c.16,2.56.17,6,.17,6-1.84,1.31-5.69,2.17-7.86,1.56l-.06,0a8.72,8.72,0,0,1-6-6.12,10.45,10.45,0,0,1-.42-3c.48-8.51,1.11-19.12.61-27.63a14.2,14.2,0,0,0,13.13,2.46Z"
              id="elmb69tervl4a"
              style={{
                transformOrigin: '160.48989725112915px 79.36505508422852px',
              }}
              className="animable"
            />
          </g>
        </g>
        <g id="elk0wlj0b8hjd">
          <g
            style={{
              opacity: '0.6000000000000001',
              transformOrigin: '182.80500030517578px 60.47184085845947px',
            }}
            className="animable"
          >
            <path
              d="M168,64.54a7.57,7.57,0,0,0,1.07-.66L171.92,62a31.59,31.59,0,0,1,10.19-4.63,23.3,23.3,0,0,1,11.12.35,46.47,46.47,0,0,1,4.38,1.64,7.36,7.36,0,0,0-1.09-.65,20.43,20.43,0,0,0-3.2-1.3A22.37,22.37,0,0,0,182,56.9a29.89,29.89,0,0,0-10.27,4.82c-1.2.82-2.14,1.52-2.79,2A5.39,5.39,0,0,0,168,64.54Z"
              style={{
                fill: 'rgb(255, 255, 255)',
                transformOrigin: '182.80500030517578px 60.47184085845947px',
              }}
              id="els1gw5v39sq"
              className="animable"
            />
          </g>
        </g>
        <g id="elitcrrprseab">
          <g
            style={{
              opacity: '0.6000000000000001',
              transformOrigin: '144.5199966430664px 52.08400869369507px',
            }}
            className="animable"
          >
            <path
              d="M138.5,48.28c0,.08.89-.05,2.28.08a11,11,0,0,1,8.76,5.74c.68,1.23.91,2.09,1,2.07a5.86,5.86,0,0,0-.69-2.22,10.51,10.51,0,0,0-9-5.92A5.57,5.57,0,0,0,138.5,48.28Z"
              style={{
                fill: 'rgb(255, 255, 255)',
                transformOrigin: '144.5199966430664px 52.08400869369507px',
              }}
              id="els5yrfo45coq"
              className="animable"
            />
          </g>
        </g>
        <polygon
          points="119.18 45.28 117.35 267.95 119.01 268.3 121.09 45.36 119.18 45.28"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '119.21999740600586px 156.7899932861328px',
          }}
          id="el1xent4v5ic5"
          className="animable"
        />
      </g>
      <g
        id="freepik--Characters--inject-66"
        style={{ transformOrigin: '384.57032775878906px 261.19702911376953px' }}
        className="animable"
      >
        <path
          d="M572.23,448.27l4.65,14.61s-13.3,9.64-12.7,12.42l28.66-8-6.31-23.06Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '578.5001173019409px 459.7699890136719px',
          }}
          id="elmgt9gp9wvjf"
          className="animable"
        />
        <path
          d="M585.39,459.17a1.2,1.2,0,0,1,1.18,1.11,1.17,1.17,0,0,1-1.09,1.18,1.29,1.29,0,0,1-1.24-1.18,1.21,1.21,0,0,1,1.27-1.11"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '585.4050343036652px 460.31415462493896px',
          }}
          id="elch4103of89d"
          className="animable"
        />
        <path
          d="M593,467.9l-.61-2.23-27.52,7.86s-1.12.91-.72,1.77Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '578.5318717956543px 470.48497009277344px',
          }}
          id="el5u8dtlob1sj"
          className="animable"
        />
        <path
          d="M576.37,462.87c0,.14.76,0,1.58.26s1.34.75,1.45.65-.32-.84-1.31-1.13S576.3,462.75,576.37,462.87Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '577.8912626504898px 463.1691150069237px',
          }}
          id="el0430qwy7io26"
          className="animable"
        />
        <path
          d="M573.71,465c0,.14.68.21,1.32.67s1,1.05,1.09,1,0-.86-.8-1.41S573.68,464.82,573.71,465Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '574.9287352561951px 465.76312816143036px',
          }}
          id="elfrl9sw0m7s7"
          className="animable"
        />
        <path
          d="M573,469c.13,0,.13-.76-.44-1.42s-1.31-.79-1.34-.66.49.43,1,1S572.86,469.05,573,469Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '572.1446140408516px 467.9389474391937px',
          }}
          id="elsx9exvszlr"
          className="animable"
        />
        <path
          d="M575.68,459.42c.09.11.68-.26,1.49-.43s1.49-.09,1.53-.23-.69-.47-1.64-.26S575.58,459.33,575.68,459.42Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '577.1847676038742px 458.9359996318817px',
          }}
          id="el28t1udezuuj"
          className="animable"
        />
        <path
          d="M521.28,430.68,531,447.45S514.12,454,514,457.18l32.93.16,0-2.56-7.28-24.44Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '530.4649963378906px 443.8399963378906px',
          }}
          id="elrfsse65m6sj"
          className="animable"
        />
        <path
          d="M541.18,445.86a1.34,1.34,0,0,1,1,1.52,1.31,1.31,0,0,1-1.5,1,1.43,1.43,0,0,1-1-1.62,1.35,1.35,0,0,1,1.67-.82"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '540.9280309677124px 447.12960600852966px',
          }}
          id="el766e9hw1j4"
          className="animable"
        />
        <path
          d="M546.91,457.34l0-2.56-31.63.71s-1.45.66-1.27,1.69Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '530.4522533416748px 456.05999755859375px',
          }}
          id="ely30qpqchmpm"
          className="animable"
        />
        <path
          d="M531.12,447.29c0,.16.82.22,1.61.72s1.24,1.18,1.38,1.11-.11-1-1.08-1.58S531.09,447.14,531.12,447.29Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '532.6326471567154px 448.1328099966049px',
          }}
          id="elvx2rq88rtc"
          className="animable"
        />
        <path
          d="M527.39,449c0,.16.67.42,1.22,1.09s.73,1.39.89,1.38.25-.92-.46-1.74S527.39,448.86,527.39,449Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '528.5010260343552px 450.20480811595917px',
          }}
          id="elvfa07emfwp"
          className="animable"
        />
        <path
          d="M525.44,453.21c.15,0,.36-.77-.07-1.64s-1.18-1.22-1.25-1.08.41.6.75,1.32S525.28,453.2,525.44,453.21Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '524.869303047657px 451.83504354953766px',
          }}
          id="elo4mna7f2a4b"
          className="animable"
        />
        <path
          d="M529,443.8c.07.15.81-.09,1.72,0s1.62.32,1.7.18-.61-.7-1.68-.74S528.93,443.68,529,443.8Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '530.71084856987px 443.63087609410286px',
          }}
          id="elvdwulff80d"
          className="animable"
        />
        <polygon
          points="580.57 298.44 582.41 324.74 592.23 326.63 594.28 297.33 580.57 298.44"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '587.4250183105469px 311.97999572753906px',
          }}
          id="elvezs5nv8dco"
          className="animable"
        />
        <path
          d="M577.49,346.65s-.3-6.5-.5-9.09a3.75,3.75,0,0,1,.59-2.35l4.83-7.5v-3l9.82,1.9s.73,7.53.73,8.77c0,.81-.3,5-.52,7.87a3,3,0,0,1-2.81,2.8h0a2.44,2.44,0,0,1-2.26,3,5,5,0,0,1-3.91,1.32l-1,0s-.2,1.06-1.89,1.06-1.09-2.29-1.09-2.29l-.24-2.78Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '584.9685711860657px 338.0699768066406px',
          }}
          id="ellfw7reuesw"
          className="animable"
        />
        <path
          d="M579.52,338.61a26.39,26.39,0,0,1-.29,9,27.4,27.4,0,0,1,0-4.49A25.15,25.15,0,0,1,579.52,338.61Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '579.456699103117px 343.1099853515625px',
          }}
          id="el10qti8nikf7"
          className="animable"
        />
        <path
          d="M584.18,341.79a10,10,0,0,1-.24,4.39,10.48,10.48,0,0,1-1.62,4.09c-.14-.07.6-1.87,1.11-4.2S584,341.79,584.18,341.79Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '583.3109375238419px 346.03001403808594px',
          }}
          id="elqhj18zyif7d"
          className="animable"
        />
        <path
          d="M587.71,341.88a12.91,12.91,0,0,1-.93,7.39,28.42,28.42,0,0,1,.49-3.69A29.91,29.91,0,0,1,587.71,341.88Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '587.335299372673px 345.57501220703125px',
          }}
          id="elpmlm08fupto"
          className="animable"
        />
        <path
          d="M589.75,341.14a5.56,5.56,0,0,1,.33,2.77,5.62,5.62,0,0,1-.57,2.74,11.66,11.66,0,0,1,0-2.76A12.26,12.26,0,0,1,589.75,341.14Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '589.7793172597885px 343.8949890136719px',
          }}
          id="elpray8ntzrmd"
          className="animable"
        />
        <path
          d="M523.33,201.42a3.64,3.64,0,0,1-1.74-7,3.79,3.79,0,0,1,3.13-6.47,4.53,4.53,0,0,1,6.73-3.89,5.09,5.09,0,0,1,6.26-.3,3.62,3.62,0,0,1,3.36,6.06"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '530.6949558258057px 192.13390064239502px',
          }}
          id="eldhfp0tkz6jv"
          className="animable"
        />
        <path
          d="M522.81,201.94a15.44,15.44,0,0,1,15-14.62l.8,0c8.63.26,13.23,7.73,12.73,16.35l-.44,28.72,0,1.39-19.76,4.55L530.9,231s-8.32-1.06-8.65-9.33C522.08,217.67,522.42,209.41,522.81,201.94Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '536.790961265564px 212.82500457763672px',
          }}
          id="els2cto67ru1q"
          className="animable"
        />
        <path
          d="M530.83,231a20.08,20.08,0,0,0,10.76-3.48s-2.38,6-10.67,5.51Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '536.2100219726562px 230.28923845291138px',
          }}
          id="el3d9svipf3ca"
          className="animable"
        />
        <path
          d="M526.54,208.35a1.18,1.18,0,0,0,1.17,1.16,1.14,1.14,0,0,0,1.19-1.1,1.19,1.19,0,0,0-1.17-1.17A1.13,1.13,0,0,0,526.54,208.35Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '527.719970703125px 208.37477719783783px',
          }}
          id="ellezvec5vw49"
          className="animable"
        />
        <path
          d="M524.71,205.94c.15.15,1-.54,2.3-.57s2.22.58,2.35.42-.09-.35-.5-.63a3.33,3.33,0,0,0-1.9-.53,3.11,3.11,0,0,0-1.82.65C524.76,205.59,524.63,205.87,524.71,205.94Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '527.042373418808px 205.29496091604233px',
          }}
          id="eltzhj767eo9l"
          className="animable"
        />
        <path
          d="M538.76,209a1.19,1.19,0,0,0,1.17,1.16,1.13,1.13,0,0,0,1.19-1.1,1.17,1.17,0,0,0-1.17-1.16A1.13,1.13,0,0,0,538.76,209Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '539.9400024414062px 209.02999758720398px',
          }}
          id="elacsltai99i7"
          className="animable"
        />
        <path
          d="M537.22,205.83c.15.15,1-.54,2.3-.57s2.22.57,2.36.41-.09-.34-.51-.63a3.24,3.24,0,0,0-1.89-.52,3.14,3.14,0,0,0-1.83.65C537.27,205.48,537.14,205.76,537.22,205.83Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '539.5591804981232px 205.18442958593369px',
          }}
          id="elzmzsefe42k8"
          className="animable"
        />
        <path
          d="M532.87,215.39a8.94,8.94,0,0,0-2.08-.31c-.33,0-.64-.08-.7-.3a1.73,1.73,0,0,1,.19-1c.29-.8.58-1.63.89-2.5a43,43,0,0,0,2-6.53,43.13,43.13,0,0,0-2.5,6.35c-.29.88-.58,1.72-.85,2.52a1.89,1.89,0,0,0-.13,1.28.81.81,0,0,0,.55.46,2.3,2.3,0,0,0,.55.06A8.58,8.58,0,0,0,532.87,215.39Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '531.4015072584152px 210.1095790863037px',
          }}
          id="eli3li318ymwr"
          className="animable"
        />
        <path
          d="M536.64,216.17c-.21,0-.18,1.37-1.33,2.39s-2.63.9-2.63,1.09.33.26,1,.26a3.45,3.45,0,0,0,2.2-.84,3,3,0,0,0,1-2C536.89,216.49,536.73,216.16,536.64,216.17Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '534.7802228927612px 218.03988993167877px',
          }}
          id="elke7lgnytffl"
          className="animable"
        />
        <path
          d="M536.75,200.85c.13.34,1.4.14,2.9.28s2.71.51,2.9.2-.13-.48-.63-.8a5.06,5.06,0,0,0-4.42-.36C537,200.41,536.69,200.69,536.75,200.85Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '539.6740577220917px 200.6368557214737px',
          }}
          id="elpmft42a0it"
          className="animable"
        />
        <path
          d="M525.07,202.25c.23.28,1.1-.05,2.15-.09s1.95.14,2.15-.17c.09-.15-.06-.43-.46-.7a3,3,0,0,0-1.76-.42,2.94,2.94,0,0,0-1.71.63C525.08,201.81,525,202.11,525.07,202.25Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '527.221118927002px 201.61193943023682px',
          }}
          id="eli2abu59fdfd"
          className="animable"
        />
        <path
          d="M523.5,198.12s2-5.24,4.5-6.52c3-1.56,4.39,1.73,7.25.84s5.71-2.37,8.72-.22c3.3,2.34,1.83,4.1,2.13,7.77,1.23,14.87,4.07,19,4.65,12,.06-.77,2.18-1.45,2.4-4.7.29-4.22.31-9.34-.71-12.3-.87-2.5-2.35-4.2-5-6.05-4.15-2.91-9.74-2.82-13.52-2.33S523,191.64,523.5,198.12Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '538.3986759185791px 200.82555770874023px',
          }}
          id="elzxeu5mzigje"
          className="animable"
        />
        <path
          d="M550.21,211.75a2.26,2.26,0,0,1,2.37-2.24c1.55.11,3.29.93,3.28,4.13,0,5.66-5.71,4.47-5.72,4.31S550.18,214.12,550.21,211.75Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '552.9994461536407px 213.8345947265625px',
          }}
          id="elhrlp74n6ym"
          className="animable"
        />
        <path
          d="M551.38,215.82s.1.07.27.15a1,1,0,0,0,.74,0,2.47,2.47,0,0,0,1.14-2.19,3.2,3.2,0,0,0-.28-1.41,1.1,1.1,0,0,0-.74-.76.51.51,0,0,0-.58.26c-.08.16,0,.28-.07.29s-.12-.1-.07-.33a.61.61,0,0,1,.22-.36.77.77,0,0,1,.55-.14,1.4,1.4,0,0,1,1,.88,3.25,3.25,0,0,1,.34,1.58,2.56,2.56,0,0,1-1.45,2.44,1,1,0,0,1-.9-.15C551.39,216,551.36,215.83,551.38,215.82Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '552.6389353275299px 213.80045437812805px',
          }}
          id="el6vedwl9ffht"
          className="animable"
        />
        <path
          d="M549.79,200.78a5.49,5.49,0,0,1-2.36,1.18,1.86,1.86,0,0,1-2.09-1.24c-.08-.4,0-.86-.26-1.15s-.89-.23-1.36-.16a3.61,3.61,0,0,1-3.82-2.49,1.52,1.52,0,0,1-2,.25,7.83,7.83,0,0,1-1.59-1.61,2.32,2.32,0,0,0-2-.91,5.44,5.44,0,0,1-1.22.3c-.75,0-1.14-.9-1.27-1.64s-.24-1.59-.88-2a3,3,0,0,0-2,0c-.68.12-1.57,0-1.76-.68a1.31,1.31,0,0,1,.22-1,3.66,3.66,0,0,1,4.29-1.5,5,5,0,0,1,9.1-1.23,5,5,0,0,1,8.11,1.62,3.65,3.65,0,0,1,4.27,5.2,3.45,3.45,0,0,1,2,2.71,2,2,0,0,1-2.19,2.09,2,2,0,0,1-3.45,2.12"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '541.164963722229px 193.23288536071777px',
          }}
          id="elrqvfswecyd"
          className="animable"
        />
        <path
          d="M531.29,189.79s0,0,0,.11,0,.17,0,.3a3.59,3.59,0,0,0,.45,1.08,4,4,0,0,0,1.29,1.3,3.79,3.79,0,0,0,2.34.6l-.1-.13a2,2,0,0,0,.15,1.56,6.29,6.29,0,0,0,1,1.37,4.89,4.89,0,0,0,.65.63,2.1,2.1,0,0,0,.91.31,2.07,2.07,0,0,0,1.8-.71l-.21-.05A4.25,4.25,0,0,0,541.5,199a3.06,3.06,0,0,0,1.88.56,5.47,5.47,0,0,0,1.82-.45l-.15-.07a4.35,4.35,0,0,0,1.39,1.71,2.37,2.37,0,0,0,2,.49,3.13,3.13,0,0,0,2.34-2.51l-.13.06a2.9,2.9,0,0,0,2,.23,3.11,3.11,0,0,0,1.34-.64,2.68,2.68,0,0,0,.61-.71,1.21,1.21,0,0,0,.14-.3,3.38,3.38,0,0,1-.81.93,3.13,3.13,0,0,1-1.31.59,2.77,2.77,0,0,1-1.84-.25l-.11-.06,0,.12a3,3,0,0,1-2.2,2.33,2.18,2.18,0,0,1-1.81-.46,4.25,4.25,0,0,1-1.3-1.62l0-.11-.11,0a5.19,5.19,0,0,1-1.74.44,2.88,2.88,0,0,1-1.73-.52,4,4,0,0,1-1.78-2.72l-.05-.27-.17.21a1.81,1.81,0,0,1-1.59.62,1.69,1.69,0,0,1-.8-.26,4.89,4.89,0,0,1-.62-.59,5.67,5.67,0,0,1-1-1.31,1.86,1.86,0,0,1-.16-1.41l0-.14-.14,0a3.69,3.69,0,0,1-2.24-.54,4,4,0,0,1-1.28-1.23A4.32,4.32,0,0,1,531.29,189.79Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '543.0150146484375px 195.54083251953125px',
          }}
          id="el6h2vx8yu3j"
          className="animable"
        />
        <path
          d="M499.43,289l-19.52-9.88-6.84,7.19s18.9,16,23.54,17C496.61,303.29,502.11,299.51,499.43,289Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '486.61805629730225px 291.2149963378906px',
          }}
          id="elomyp7l0z83i"
          className="animable"
        />
        <path
          d="M474.18,269.65l-4.76-.93s-7.09,14-6,16.51,12.83,1.9,12.83,1.9l4-5.33s.39-1.12.41-5.87C480.69,273.05,474.18,269.65,474.18,269.65Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '471.9830732345581px 277.95763397216797px',
          }}
          id="elaboy97pglpj"
          className="animable"
        />
        <path
          d="M463.13,277.37s-1.29,3-.53,3.93c0,0-1,2.94.8,3.93,0,0,7.2-1.75,7.43-3.43l.23-1.68s5.48-.08,3.5-2.75c0,0,1.53-2.35,0-3l-1.79-.38s2.26-1.83.83-2.55a32.79,32.79,0,0,0-4.07-1.61l-5.4.92Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '468.7814984321594px 277.53001403808594px',
          }}
          id="el66qb37wity6"
          className="animable"
        />
        <path
          d="M463.13,277.37a1.52,1.52,0,0,1,0-.47l.15-1.33c.17-1.22.39-2.87.66-4.88v-.13l.13,0,5.39-1h.11a35.78,35.78,0,0,1,3.43,1.29,5.49,5.49,0,0,1,.9.46,1,1,0,0,1,.37.53,1.16,1.16,0,0,1-.05.62,4.38,4.38,0,0,1-1.32,1.68l-.11-.45,1.8.38h.05a1.41,1.41,0,0,1,.66.6,1.57,1.57,0,0,1,.16.87,4.24,4.24,0,0,1-.49,1.57l-.22.38v-.3a1.81,1.81,0,0,1,.4,1.62,2.06,2.06,0,0,1-1.24,1,9.06,9.06,0,0,1-2.87.49l.25-.21c-.07.47-.13.93-.2,1.39a2.7,2.7,0,0,1-.06.36,1,1,0,0,1-.18.4,2.7,2.7,0,0,1-.54.53,10.75,10.75,0,0,1-2.39,1.21,38.69,38.69,0,0,1-4.5,1.37l-.07,0-.07,0a2.46,2.46,0,0,1-1.14-2.12,6,6,0,0,1,.3-2l0,.13a1.54,1.54,0,0,1-.26-1,4.29,4.29,0,0,1,.1-.83,9.84,9.84,0,0,1,.35-1.24,4.46,4.46,0,0,1,.45-1,10,10,0,0,1-.3,1,10,10,0,0,0-.29,1.24,2.32,2.32,0,0,0,.17,1.57l.05.07,0,.07a5.79,5.79,0,0,0-.23,1.91,2.11,2.11,0,0,0,1,1.8l-.14,0a39.9,39.9,0,0,0,4.42-1.42,10.62,10.62,0,0,0,2.27-1.17,2.45,2.45,0,0,0,.43-.42,1,1,0,0,0,.15-.55c.06-.46.12-.92.19-1.39l0-.21h.22a8.55,8.55,0,0,0,2.69-.47,1.54,1.54,0,0,0,.94-.74,1.32,1.32,0,0,0-.33-1.13l-.1-.15.09-.15a3.54,3.54,0,0,0,.19-.33,3.61,3.61,0,0,0,.44-1.36.89.89,0,0,0-.51-1h.05l-1.79-.38-.5-.11.39-.34a3.89,3.89,0,0,0,1.16-1.43.47.47,0,0,0-.14-.61,5.93,5.93,0,0,0-.8-.41,35.67,35.67,0,0,0-3.37-1.3h.11l-5.41.88.15-.15c-.34,2-.61,3.66-.82,4.88-.1.52-.18.95-.24,1.31S463.15,277.38,463.13,277.37Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '468.80353450775146px 277.4549865722656px',
          }}
          id="elblque0z201k"
          className="animable"
        />
        <path
          d="M471.1,280.08c0,.16-1.87,0-4.12.23a26.73,26.73,0,0,0-4,.91,6.59,6.59,0,0,1,3.93-1.43A9.22,9.22,0,0,1,471.1,280.08Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '467.0400085449219px 280.4456211924553px',
          }}
          id="elgmz3bclau4n"
          className="animable"
        />
        <path
          d="M463.81,277.73a11.39,11.39,0,0,1,5.33-1.25,11.23,11.23,0,0,1,5.41.89,50,50,0,0,0-5.39-.37C466.18,277.09,463.86,277.89,463.81,277.73Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '469.17999267578125px 277.0959569811821px',
          }}
          id="el81q3vgipt6v"
          className="animable"
        />
        <path
          d="M464.73,274.07a7.73,7.73,0,0,1,4.16-1,7.51,7.51,0,0,1,4.18.88c-.05.15-1.87-.42-4.18-.36S464.79,274.22,464.73,274.07Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '468.9000244140625px 273.57027131319046px',
          }}
          id="el2qov0y0tkw"
          className="animable"
        />
        <path
          d="M474.18,272.12a12.1,12.1,0,0,1,2.27,1.81l.14.13-.11.16a9,9,0,0,0-1.07,2.48,9.55,9.55,0,0,0-.2,3.87,15.08,15.08,0,0,1,.32,1.63,3.54,3.54,0,0,1-.68-1.55,8.33,8.33,0,0,1,0-4.09,8.19,8.19,0,0,1,1.21-2.59l0,.29A11.91,11.91,0,0,1,474.18,272.12Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '475.38499450683594px 277.1600036621094px',
          }}
          id="elq1po04pfjg"
          className="animable"
        />
        <path
          d="M557.11,330.3l-32.59,3.27,22.33,58.27,9.44,14.82,15.61,51.82,17.94-5.94C589.58,443.63,557.11,330.3,557.11,330.3Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '557.1799621582031px 394.3899841308594px',
          }}
          id="elqetpg8v8ax"
          className="animable"
        />
        <path
          d="M531.1,333.58S503.38,365.17,501,369.75s-4.66,7.23-2.07,14,28.34,63.55,28.34,63.55,18.27-4.09,19-5.38c0,0-12.52-38.07-14.17-44a89.91,89.91,0,0,0-6-14.74s22.77-19.87,26.66-24.21,21.26-15.52,20.37-27.33c-.58-7.71-2-9.91-2-9.91Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '535.473014831543px 384.51499938964844px',
          }}
          id="elv4mo8w7uenf"
          className="animable"
        />
        <path
          d="M530.46,334.11a66.12,66.12,0,0,1-7.55,9.05,32.37,32.37,0,0,1,3.58-4.69A33.58,33.58,0,0,1,530.46,334.11Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '526.6850280761719px 338.6349792480469px',
          }}
          id="el75lmfaocjqq"
          className="animable"
        />
        <path
          d="M526,382.93a29.79,29.79,0,0,1-3.12-.24c-1.7-.09-3.09.08-3.12-.06a8.29,8.29,0,0,1,6.24.3Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '522.8800048828125px 382.54505783319473px',
          }}
          id="eldrt3al7wzwk"
          className="animable"
        />
        <path
          d="M562.51,349.6a6.68,6.68,0,0,1-.91.91L559,352.86c-2.18,2-5.16,4.76-8.39,7.88s-6.15,6-8.3,8c-1.07,1-1.94,1.82-2.56,2.37a6,6,0,0,1-1,.82,5.45,5.45,0,0,1,.85-1l2.45-2.49c2.08-2.1,4.95-5,8.19-8.11s6.26-5.87,8.51-7.79c1.12-1,2-1.72,2.69-2.23A6.06,6.06,0,0,1,562.51,349.6Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '550.6300048828125px 360.76499938964844px',
          }}
          id="elum49jkaqyuf"
          className="animable"
        />
        <path
          d="M563,398.3a13.8,13.8,0,0,1-4.35,5.95,24,24,0,0,1,2.16-3A23.76,23.76,0,0,1,563,398.3Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '560.8250427246094px 401.2749938964844px',
          }}
          id="el9glme1f6ezu"
          className="animable"
        />
        <path
          d="M516.57,244.68a71.59,71.59,0,0,0-3.45,7.87c-.77,2-5.68,18.59-5.68,18.59l-6.14,17.31a2,2,0,0,0-2.93,1.12c-.88,2.31-2.81,14.33-2.81,14.33a12.45,12.45,0,0,0,6.51,1.15c3.62-.38,13.62-5.12,13.62-5.12l2.67-5.72,5.77-12.71.88-41.68S518.12,242.23,516.57,244.68Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '510.2850036621094px 272.4623832702637px',
          }}
          id="el6hy98jla4qm"
          className="animable"
        />
        <path
          d="M573.16,298l-.33-15.93-2.59-42.7-16.14-5.67-2.28-6.59-17.55,10-4.14-3.92-1.23,4.88L525,239.75l-6.65,16.1,1.78,27.2s1.33,43,5,51c0,0,10.08-4.13,19.14-3.48s22.15-1.62,22.15-1.62,7.33-2.4,8,.37"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '546.385009765625px 280.58001708984375px',
          }}
          id="el1fcqy6dy78d"
          className="animable"
        />
        <path
          d="M573.13,300.84l-.34-15.92-2.58-42.7-16.15-5.67-2.27-6.6-17.55,10-4.15-3.92L528.86,241,525,242.56l-6.65,16.11,1.78,27.2s1.33,43,5,50.95c0,0,10.08-4.12,19.14-3.47s22.16-1.63,22.16-1.63,7.33-2.4,8,.38"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '546.3899841308594px 283.38499450683594px',
          }}
          id="el2b92oksy2sb"
          className="animable"
        />
        <path
          d="M557,270.74a11.82,11.82,0,0,1-2.4.08l-5.78,0-5.78,0a12.11,12.11,0,0,1-2.4-.09,10.61,10.61,0,0,1,2.39-.28c1.48-.1,3.52-.17,5.79-.17s4.31.08,5.79.18A10.31,10.31,0,0,1,557,270.74Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '548.8199462890625px 270.5638053715229px',
          }}
          id="elf7sjhmi324"
          className="animable"
        />
        <path
          d="M556.93,273.55a10.91,10.91,0,0,1-2.4.08l-5.78,0-5.78,0a11.82,11.82,0,0,1-2.4-.08,10,10,0,0,1,2.39-.28c1.48-.1,3.53-.18,5.79-.18s4.31.09,5.79.19A10.74,10.74,0,0,1,556.93,273.55Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '548.7499389648438px 273.37613466382027px',
          }}
          id="elh86hu2hm3q"
          className="animable"
        />
        <path
          d="M556.9,276.37a12,12,0,0,1-2.41.08l-5.77,0-5.78,0a11.22,11.22,0,0,1-2.4-.09,10.45,10.45,0,0,1,2.38-.28c1.48-.1,3.53-.17,5.8-.17s4.31.08,5.79.18A10.31,10.31,0,0,1,556.9,276.37Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '548.7200012207031px 276.19363328814507px',
          }}
          id="el79echgzn34e"
          className="animable"
        />
        <path
          d="M556.86,279.18a11.22,11.22,0,0,1-2.4.09l-5.78,0H542.9a11.75,11.75,0,0,1-2.4-.08,10,10,0,0,1,2.39-.28c1.48-.1,3.53-.18,5.79-.18s4.31.09,5.79.19A10.74,10.74,0,0,1,556.86,279.18Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '548.6799926757812px 279.0140004456043px',
          }}
          id="el7v17no8q0an"
          className="animable"
        />
        <path
          d="M569.77,239.28a18,18,0,0,1,7.42,6.57c3.38,5,13.31,33.53,13.47,35.46h0l2.3,5.63a9.93,9.93,0,0,1,1.88,5.48v6.44s-9.25-2.11-14.21,1.07a6.15,6.15,0,0,1-2-5.36,10,10,0,0,1,.93-2.8s-2.33.57-2.8-.64a5.72,5.72,0,0,1,0-2.16l-9.28-14.34-2.74-13.07S561.4,242.82,569.77,239.28Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '579.4609689712524px 269.6050109863281px',
          }}
          id="elkjvthbtot4r"
          className="animable"
        />
        <path
          d="M535.36,331.14a.79.79,0,0,1-.06-.23l-.1-.66c-.09-.63-.21-1.48-.36-2.56-.3-2.27-.71-5.47-1.21-9.41-1-8-2.26-19-3.13-31.16a172.07,172.07,0,0,1-.5-17.25c.21-5.31.78-10.06,1.31-14s1.08-7.17,1.46-9.38l.45-2.54c0-.27.1-.48.13-.66s0-.23.06-.22a.58.58,0,0,1,0,.23c0,.18,0,.4-.08.66-.08.63-.2,1.48-.35,2.56-.32,2.22-.8,5.42-1.3,9.4s-1,8.71-1.19,14,.12,11.1.54,17.19c.87,12.19,2.1,23.19,3,31.16.44,3.94.79,7.15,1,9.43.11,1.08.2,1.93.26,2.57,0,.26,0,.48.06.67A.7.7,0,0,1,535.36,331.14Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '532.6622233390808px 287.1044044494629px',
          }}
          id="el0l2u0yqpbxla"
          className="animable"
        />
        <path
          d="M541.51,261.07a8.41,8.41,0,0,1,1.06-.05l3.1-.06,11.3-.1h.21v.22c0,5.18,0,11.38.05,18.07v.12l-.09.08c-.5.42-1,.85-1.59,1.28a31.68,31.68,0,0,1-3,2.07,9.33,9.33,0,0,1-3.34,1.37,6.85,6.85,0,0,1-3.46-.52,15.28,15.28,0,0,1-2.89-1.62c-.44-.31-.86-.63-1.27-.95a2.26,2.26,0,0,1-.58-.61,3.1,3.1,0,0,1-.36-.73,11.57,11.57,0,0,1-.51-2.94,43.37,43.37,0,0,1,.07-5.28c.21-3.22.57-5.81.83-7.59.13-.89.24-1.58.33-2a3.85,3.85,0,0,1,.16-.71,3.25,3.25,0,0,1-.06.72c-.06.52-.13,1.21-.23,2.06-.2,1.78-.5,4.37-.66,7.58a45.44,45.44,0,0,0,0,5.23,11.39,11.39,0,0,0,.51,2.81,2.23,2.23,0,0,0,.8,1.13c.4.31.82.62,1.26.92a14.37,14.37,0,0,0,2.8,1.56,6.48,6.48,0,0,0,3.2.48,8.91,8.91,0,0,0,3.14-1.31,32.09,32.09,0,0,0,3-2.05c.55-.42,1.09-.85,1.57-1.26l-.09.2c0-6.69,0-12.89,0-18.07l.22.21-11.18-.1-3.14-.06-.84,0Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '548.6602907180786px 272.48537254333496px',
          }}
          id="eldv0bcvduptr"
          className="animable"
        />
        <path
          d="M551.82,227.14a46.08,46.08,0,0,0-7,4c-4.92,3.13-10.55,6.08-10.55,6.08l1.09,8.2L554,234.12"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '544.135009765625px 236.27999877929688px',
          }}
          id="el60n5mbzghzl"
          className="animable"
        />
        <path
          d="M554,234.12a1.74,1.74,0,0,1-.34.26l-1,.68-3.9,2.45-13.22,8.08-.34.2,0-.39c-.14-1.07-.29-2.19-.44-3.33-.22-1.67-.43-3.29-.64-4.86l0-.18.15-.08c5.11-2.68,9.42-5.3,12.5-7.2,1.56-.92,2.84-1.61,3.74-2a6.2,6.2,0,0,1,1.43-.57,1.46,1.46,0,0,1-.34.2l-1,.53c-.87.48-2.12,1.21-3.65,2.16-3,2-7.32,4.67-12.43,7.37l.14-.26c.2,1.57.42,3.2.64,4.86l.44,3.33-.39-.18,13.31-7.94,4-2.31,1.09-.6A1.78,1.78,0,0,1,554,234.12Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '544.0599670410156px 236.48499298095703px',
          }}
          id="ele1woc7zubmt"
          className="animable"
        />
        <polyline
          points="530.13 233.25 534.27 237.17 532.92 246.15 528.9 238.45"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '531.5850219726562px 239.6999969482422px',
          }}
          id="elgmhncsg5c1"
          className="animable"
        />
        <path
          d="M528.9,238.45a13.54,13.54,0,0,1,1.28,2.11c.76,1.35,1.79,3.26,3,5.48l-.47.08c.14-1,.29-2,.45-3,.34-2.16.65-4.19.93-6l.07.2c-1.23-1.2-2.25-2.2-2.94-2.91a6.42,6.42,0,0,1-1-1.18,7.79,7.79,0,0,1,1.22,1c.76.65,1.81,1.61,3.08,2.77l.08.08,0,.12c-.25,1.77-.55,3.8-.86,6-.16,1-.31,2.06-.46,3l-.12.77-.35-.69c-1.15-2.23-2.13-4.17-2.8-5.56A14.52,14.52,0,0,1,528.9,238.45Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '531.7500610351562px 240.0999984741211px',
          }}
          id="elvmxgepzjtl"
          className="animable"
        />
        <path
          d="M567.2,242a32.39,32.39,0,0,0-3.06,4.64,18.47,18.47,0,0,0-1.83,5.86,20.51,20.51,0,0,0,.43,7.71v0c.68,1.84,1.43,3.8,2.24,5.79.68,1.66,1.37,3.25,2.14,4.74s1.46,3,2.12,4.39c1.33,2.8,2.53,5.32,3.63,7.38s2.08,3.69,2.79,4.78a19.35,19.35,0,0,1,1.1,1.72,2.72,2.72,0,0,1-.35-.4c-.22-.27-.54-.66-.91-1.2a49.3,49.3,0,0,1-3-4.72c-1.15-2-2.39-4.56-3.74-7.35-.68-1.4-1.4-2.85-2.14-4.37a51,51,0,0,1-2.17-4.77c-.81-2-1.56-4-2.23-5.82h0v0a20.7,20.7,0,0,1-.38-7.88,18.62,18.62,0,0,1,2-6,20.08,20.08,0,0,1,2.32-3.42c.31-.37.58-.63.75-.81S567.19,242,567.2,242Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '569.1935019493103px 265.5050048828125px',
          }}
          id="elaj7mqav3ook"
          className="animable"
        />
        <path
          d="M517.4,254.68a14,14,0,0,1,.26,1.74c.13,1.12.3,2.74.48,4.74.38,4,.81,9.56,1.25,15.69s.81,11.59,1.09,15.69c.13,1.95.24,3.55.32,4.76a11,11,0,0,1,.06,1.75,13.6,13.6,0,0,1-.26-1.73c-.13-1.12-.3-2.74-.48-4.75-.38-4-.81-9.56-1.25-15.69s-.81-11.59-1.09-15.69c-.13-1.94-.24-3.55-.32-4.76A9.67,9.67,0,0,1,517.4,254.68Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '519.1280101537704px 276.864990234375px',
          }}
          id="elecq9pw18q6t"
          className="animable"
        />
        <path
          d="M557.21,265.74a128.65,128.65,0,0,1-16.35,0,128.65,128.65,0,0,1,16.35,0Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '549.0350341796875px 265.73998069763184px',
          }}
          id="elzbx3qbbivrs"
          className="animable"
        />
        <path
          d="M506,297.33c-.15,0-.85-2.24-2-4.9a13.63,13.63,0,0,0-1.75-3.23c-.6-.71-1.22-.81-1.2-.9s.71-.08,1.46.64a10.46,10.46,0,0,1,2,3.28A16.23,16.23,0,0,1,506,297.33Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '503.5247714519501px 292.7953848838806px',
          }}
          id="el2147nzjp5wn"
          className="animable"
        />
        <path
          d="M509.78,295.62c-.06,0-.47-.45-1.1-1.25a32,32,0,0,0-2.56-3A13,13,0,0,0,503,289a12.81,12.81,0,0,1-1.48-.72,3.37,3.37,0,0,1,1.64.39,10.47,10.47,0,0,1,3.33,2.31,19.08,19.08,0,0,1,2.49,3.17A5,5,0,0,1,509.78,295.62Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '505.6499938964844px 291.9496715068817px',
          }}
          id="el6pousx0lpp"
          className="animable"
        />
        <path
          d="M591,291.33a31.68,31.68,0,0,0-5.92-.44,33.16,33.16,0,0,0-5.82,1.17,11.66,11.66,0,0,1,5.78-1.69A11.52,11.52,0,0,1,591,291.33Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '585.1300048828125px 291.18301099538803px',
          }}
          id="el2xykgokyxcb"
          className="animable"
        />
        <path
          d="M587.31,285.87a29.29,29.29,0,0,0-5.74,1,28.72,28.72,0,0,0-5.21,2.59,12.77,12.77,0,0,1,10.95-3.57Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '581.8349914550781px 287.60066521167755px',
          }}
          id="elgyl1zzv6h8g"
          className="animable"
        />
        <g id="el6hc41dce9pu">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '549.096531867981px 282.8555064201355px',
            }}
            className="animable"
          >
            <path
              d="M541.22,280.3c1,1.37,2,3.3,3.25,4.39a7.11,7.11,0,0,0,4.61,1.87A7.37,7.37,0,0,0,553.2,285a11.2,11.2,0,0,0,3.77-5.84c.11-.17-2.77,2.1-4.36,3.11a7.48,7.48,0,0,1-4.6,1.36c-2.46,0-4.81-1.85-6.79-3.31"
              id="elfbscflwh79b"
              style={{
                transformOrigin: '549.096531867981px 282.8555064201355px',
              }}
              className="animable"
            />
          </g>
        </g>
        <g id="elkz5e695vq98">
          <path
            d="M534.27,238.09c-.16.14-.43,10.27-.43,10.27l18.52-13.26-17,10.27Z"
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '543.1000366210938px 241.7300033569336px',
            }}
            className="animable"
          />
        </g>
        <path
          d="M456.67,266.31a14.48,14.48,0,0,0,1.8,4.92C459.68,272.81,466,281,466,281s1.49,1.12,1.12-1.4-3-8.94-3-8.94a2,2,0,0,1,2.08-.36l3.95-.76-6.17-7Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '463.4100036621094px 271.89401721954346px',
          }}
          id="el15x4edwuyg4"
          className="animable"
        />
        <path
          d="M391.3,137.51c-8.48,6.19-5.69,16.62-7.26,19.2a6.73,6.73,0,0,0-1.41,3.23c0,1.28,1,2.41,1.06,3.68.13,1.76-1.38,3.27-2.32,4.85a8.28,8.28,0,0,0-.72,7.05c.17.48,1.08.67.94,1.21-1.42,5.17,3.39,12.6,3.79,12.59,8.39-.07,15-9.77,23.32-10.45,1.9-.15,3.11-3.46,4.68-4.44,2.14-1.33,2.91-3.73,3.53-5.94s1.31-4.67,2-7a25.26,25.26,0,0,0,1-4.59,46.51,46.51,0,0,0-.22-6.46c-.09-2,0-4-.24-6a8.66,8.66,0,0,0-2.66-5.39"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '400.05702018737793px 163.4149990081787px',
          }}
          id="elvao79saypw"
          className="animable"
        />
        <path
          d="M399.32,128.52c-5.55,1.21-11.39,5.68-13.29,11s-1.3,12.09-.89,17.75c1.71-.44,2.85.32,4.6.1a4.28,4.28,0,0,0,2.71-2,28.83,28.83,0,0,0,3.52-7.28q3.34-9,6.56-18.12"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '393.6225986480713px 142.96546173095703px',
          }}
          id="elgn19lziyvz"
          className="animable"
        />
        <path
          d="M417.3,144.69a14.08,14.08,0,0,0-15.14-13.48,14.5,14.5,0,0,0-13.38,14.57c0,6.58.23,13.2.64,15.55,1.22,7.09,5.9,9.17,7.75,9.73a9.25,9.25,0,0,0,2,.16h0a0,0,0,0,1,.05.05l-.3,8.41c.13,5.45,3.92,9.73,9.48,9.64s9.17-4.87,9.15-10.35Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '403.16478729248047px 160.24528312683105px',
          }}
          id="elq57o1jahaar"
          className="animable"
        />
        <path
          d="M390.65,150.38a1.14,1.14,0,0,0,1.14,1.13,1.1,1.1,0,0,0,1.18-1,1.13,1.13,0,0,0-1.13-1.13A1.12,1.12,0,0,0,390.65,150.38Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '391.8100128173828px 150.44533812999725px',
          }}
          id="elbtdh3sovjt"
          className="animable"
        />
        <path
          d="M390.54,147.39a21.19,21.19,0,0,1,2.3.16,19.41,19.41,0,0,1,2.15.91c.08,0,0-.28-.35-.6a4.07,4.07,0,0,0-1.7-.87,3.67,3.67,0,0,0-1.86,0C390.65,147.15,390.48,147.32,390.54,147.39Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '392.7733805179596px 147.66512393951416px',
          }}
          id="elmqtnwnwu0f"
          className="animable"
        />
        <path
          d="M402.57,150.38a1.15,1.15,0,0,0,1.14,1.13,1.11,1.11,0,0,0,1.19-1,1.15,1.15,0,0,0-1.14-1.13A1.11,1.11,0,0,0,402.57,150.38Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '403.7350311279297px 150.44500541687012px',
          }}
          id="elnjmpfr4ydd"
          className="animable"
        />
        <path
          d="M402.91,148.23a24.28,24.28,0,0,1,2.17-1.18c1.26-.48,2.37-.4,2.46-.55s-.17-.2-.66-.24a4.65,4.65,0,0,0-2,.31,4.5,4.5,0,0,0-1.68,1.07C402.87,148,402.82,148.22,402.91,148.23Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '405.214004278183px 147.24000072479248px',
          }}
          id="elb6mx3rdktxg"
          className="animable"
        />
        <path
          d="M398.63,156.67a8.58,8.58,0,0,0-2-.33c-.32,0-.62-.09-.68-.3a1.55,1.55,0,0,1,.2-.93c.29-.77.6-1.57.92-2.41a39.12,39.12,0,0,0,2.05-6.29,42,42,0,0,0-2.56,6.11c-.3.85-.6,1.65-.88,2.43a1.8,1.8,0,0,0-.15,1.23.79.79,0,0,0,.53.45,2.36,2.36,0,0,0,.55.07A8.75,8.75,0,0,0,398.63,156.67Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '397.30131816864014px 151.57723093032837px',
          }}
          id="eldci2yl47zmb"
          className="animable"
        />
        <path
          d="M399.19,171.22s4.84.31,10.85-3.36c0,0-1.84,6.31-10.93,5.62Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '404.57501220703125px 170.69636225700378px',
          }}
          id="elrqk66i00jyc"
          className="animable"
        />
        <path
          d="M399.19,159.62a2.28,2.28,0,0,1,2-.85,2,2,0,0,1,1.43.72,1.27,1.27,0,0,1,.12,1.47,1.54,1.54,0,0,1-1.64.43,4.53,4.53,0,0,1-1.61-.91,1.37,1.37,0,0,1-.36-.36.39.39,0,0,1,0-.46"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '400.98722100257874px 160.11554670333862px',
          }}
          id="elf15zxr5l2rj"
          className="animable"
        />
        <path
          d="M402.71,143.56c.16.31,1.38,0,2.86,0s2.71.19,2.86-.13c.07-.15-.18-.44-.7-.69a4.66,4.66,0,0,0-2.19-.43,4.72,4.72,0,0,0-2.17.56C402.87,143.11,402.63,143.41,402.71,143.56Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '405.56820464134216px 143.00120741128922px',
          }}
          id="el1ye6j41wqyx"
          className="animable"
        />
        <path
          d="M390.79,143.34c.22.28,1.08,0,2.12-.06s1.91.16,2.11-.14c.09-.14,0-.42-.44-.68a3,3,0,0,0-1.73-.43,3,3,0,0,0-1.68.59C390.8,142.91,390.69,143.2,390.79,143.34Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '392.9032075405121px 142.7436487674713px',
          }}
          id="el515zz5xtyy"
          className="animable"
        />
        <path
          d="M399.06,127.87a7.58,7.58,0,0,0,4.06,9.58c1.56.72,3.53,1.06,4.37,2.56.66,1.17.41,2.73,1.22,3.79s2.19,1.21,3.25,1.9a6.15,6.15,0,0,1,2.35,4.44,48.59,48.59,0,0,0,.61,5.15,4.92,4.92,0,0,0,3.22,3.75c.77-4.94,1.45-10,.9-14.94s-2.43-10-6.1-13.36-9.3-4.89-13.88-2.87"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '408.91195487976074px 143.00175857543945px',
          }}
          id="eldwcr7yg8tc8"
          className="animable"
        />
        <path
          d="M417.51,177a6.79,6.79,0,0,1-5.58-6.15c-.23-2.9,0-6.06-.52-7.68-.87-2.9-2.29-2.45-2.5-5.51s1.74-6.09,1.25-8.73-1.34-2-2.68-6.09-3.75-5.13-3.75-5.13L405,127.59l-1-.62c6-.11,12.94,3.61,15.3,9.14,1.19,2.8,1.61,6,3.73,8.23,1.34,1.37,3.23,2.16,4.35,3.71,2.38,3.33.11,8.19,1.7,12,.7,1.69,2.29,2.84,3.23,4.41,4.81,8,.77,14.12.77,14.12L417.51,177Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '419.1987543106079px 152.77381324768066px',
          }}
          id="el64mi2mekn8d"
          className="animable"
        />
        <path
          d="M383.72,158.81c.64-1.09,1.3-2.33,1-3.56a20.88,20.88,0,0,0-1.16-2.38,4.18,4.18,0,0,1,.14-3.27c.35-1.06.85-2.06,1.12-3.14.22-.86.29-1.76.59-2.6a2.73,2.73,0,0,1,1.77-1.83c.83,3.91-.48,7.94-.47,11.94a6.87,6.87,0,0,1-.26,2.6,1.9,1.9,0,0,1-2,1.29"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '385.37421917915344px 150.41999053955078px',
          }}
          id="elzwb5oiln71p"
          className="animable"
        />
        <path
          d="M426.13,177.43s.1-.19.22-.57a4.47,4.47,0,0,0,.17-1.74,7.28,7.28,0,0,0-.81-2.64,25.48,25.48,0,0,0-2-3.09,10.18,10.18,0,0,1-1.93-4.08,29.3,29.3,0,0,1-.18-5.18,11.12,11.12,0,0,0-.3-2.74,5.22,5.22,0,0,0-1.37-2.44c-.68-.7-1.53-1.26-2.29-2a5.67,5.67,0,0,1-1.71-2.65c-.6-2.09-.32-4.19-.57-6.13a11.51,11.51,0,0,0-2-5.2,11.26,11.26,0,0,0-3.78-3.37,43.9,43.9,0,0,0-4.1-1.83,15.8,15.8,0,0,1-3.29-1.76,8.08,8.08,0,0,1-2-2,5.07,5.07,0,0,1-.76-1.61,3,3,0,0,1-.12-.61s.05.21.18.59a5.34,5.34,0,0,0,.8,1.56,8.36,8.36,0,0,0,2,1.93,16.31,16.31,0,0,0,3.27,1.7,39.76,39.76,0,0,1,4.14,1.8,11.65,11.65,0,0,1,6,8.77c.25,2,0,4.07.57,6.06a5.3,5.3,0,0,0,1.61,2.52c.74.68,1.59,1.24,2.3,2a5.54,5.54,0,0,1,1.44,2.58,10.94,10.94,0,0,1,.3,2.81,29.65,29.65,0,0,0,.15,5.14,10,10,0,0,0,1.86,4,24.55,24.55,0,0,1,2,3.13,7.3,7.3,0,0,1,.77,2.71,4.2,4.2,0,0,1-.23,1.77A2,2,0,0,1,426.13,177.43Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '413.01257705688477px 152.60999298095703px',
          }}
          id="elxue0bme1wp"
          className="animable"
        />
        <path
          d="M401.92,157.65c.07,0,.17.28.14.76a3.19,3.19,0,0,1-2.18,2.78c-.46.14-.76.11-.77.05s1.08-.41,1.87-1.43A8.42,8.42,0,0,0,401.92,157.65Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '400.58774423599243px 159.47008562088013px',
          }}
          id="elk9kqk30fyf8"
          className="animable"
        />
        <path
          d="M431.26,176.46a10.33,10.33,0,0,0,2.31-1.33,7.57,7.57,0,0,0,1.92-2.42,7,7,0,0,0,.64-4,7.1,7.1,0,0,0-2.21-4.3c-1.27-1.24-3.1-2.15-4.33-3.94a6,6,0,0,1-.93-3.09,23.09,23.09,0,0,1,.18-3.32,12.3,12.3,0,0,0,0-3.32,5.55,5.55,0,0,0-1.54-2.92c-.78-.85-1.71-1.57-2.55-2.39a10.62,10.62,0,0,1-2.06-2.78c-1.05-2-1.61-4.12-2.38-6a11.93,11.93,0,0,0-3.14-4.71,14,14,0,0,0-4.29-2.51,28.26,28.26,0,0,0-7.13-1.46l-2-.19a3.57,3.57,0,0,1-.69-.1,3.4,3.4,0,0,1,.7,0c.46,0,1.13,0,2,.09a26.58,26.58,0,0,1,7.24,1.33,13.93,13.93,0,0,1,4.44,2.53,12.31,12.31,0,0,1,3.3,4.85c.8,1.91,1.37,4,2.39,5.94a10,10,0,0,0,2,2.65c.81.8,1.74,1.52,2.56,2.41a6.79,6.79,0,0,1,1.08,1.47,6,6,0,0,1,.59,1.71,12.94,12.94,0,0,1,0,3.46,24.28,24.28,0,0,0-.2,3.24,5.66,5.66,0,0,0,.84,2.86c1.1,1.65,2.91,2.59,4.23,3.89a7.43,7.43,0,0,1,2.27,4.57,7.18,7.18,0,0,1-.74,4.15,7.68,7.68,0,0,1-2.06,2.44,6.89,6.89,0,0,1-1.75,1l-.5.16Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '419.8065013885498px 152.06096267700195px',
          }}
          id="elj2h9i4uhq3r"
          className="animable"
        />
        <path
          d="M379.84,358.9l4.65,14.62s-13.3,9.63-12.7,12.42l28.66-8-6.31-23.07Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '386.1101179122925px 370.4049987792969px',
          }}
          id="elbpocazormyf"
          className="animable"
        />
        <path
          d="M393,369.8a1.23,1.23,0,0,1,1.19,1.11,1.17,1.17,0,0,1-1.09,1.18,1.27,1.27,0,0,1-1.25-1.18,1.22,1.22,0,0,1,1.27-1.1"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '393.02002453804016px 370.9449920654297px',
          }}
          id="eluhtolfh0r6"
          className="animable"
        />
        <path
          d="M400.64,378.54,400,376.3l-27.51,7.87s-1.12.91-.73,1.77Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '386.1587657928467px 381.11997985839844px',
          }}
          id="el67kdpzunu6y"
          className="animable"
        />
        <path
          d="M384,373.5c0,.14.76,0,1.58.27s1.34.74,1.46.65-.32-.84-1.32-1.14S383.92,373.38,384,373.5Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '385.5268667936325px 373.80096846818924px',
          }}
          id="elgalmxjt8g2c"
          className="animable"
        />
        <path
          d="M381.32,375.58c0,.15.68.22,1.32.68s.95,1,1.09,1,0-.86-.8-1.42S381.29,375.45,381.32,375.58Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '382.54845428466797px 376.3550439476967px',
          }}
          id="elf0fatgtk3pl"
          className="animable"
        />
        <path
          d="M380.62,379.66c.14,0,.14-.76-.44-1.43s-1.31-.79-1.34-.65.5.43,1,1S380.48,379.68,380.62,379.66Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '379.7679132223129px 378.5943409204483px',
          }}
          id="elcac2zzbnnp8"
          className="animable"
        />
        <path
          d="M383.29,370.05c.1.12.68-.26,1.49-.42s1.49-.09,1.53-.23-.69-.48-1.64-.27S383.19,370,383.29,370.05Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '384.79477047920227px 369.5681149959564px',
          }}
          id="elfn6m6a9hvc"
          className="animable"
        />
        <path
          d="M425.6,374.71l9.75,16.76s-16.91,6.58-17.05,9.73l32.92.16,0-2.56-7.29-24.44Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '434.76002502441406px 387.8600158691406px',
          }}
          id="elq0idcju0g3"
          className="animable"
        />
        <path
          d="M445.5,389.88a1.34,1.34,0,0,1,.95,1.52,1.29,1.29,0,0,1-1.49,1,1.43,1.43,0,0,1-1-1.62,1.34,1.34,0,0,1,1.66-.82"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '445.204109787941px 391.15031135082245px',
          }}
          id="elx4dk40na7ie"
          className="animable"
        />
        <path
          d="M451.22,401.36l0-2.56-31.63.71s-1.45.66-1.27,1.69Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '434.7622699737549px 400.0799865722656px',
          }}
          id="el9f0k6jy0ri7"
          className="animable"
        />
        <path
          d="M435.44,391.31c0,.16.81.22,1.61.73s1.23,1.17,1.38,1.1-.11-1-1.09-1.58S435.4,391.17,435.44,391.31Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '436.95409774780273px 392.154853284359px',
          }}
          id="el6dt07ragajb"
          className="animable"
        />
        <path
          d="M431.71,393c0,.15.66.41,1.22,1.09s.72,1.38.88,1.37.25-.92-.46-1.74S431.71,392.88,431.71,393Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '432.81600737571716px 394.20323836803436px',
          }}
          id="elg6nnpmwaca"
          className="animable"
        />
        <path
          d="M429.76,397.23c.14,0,.36-.77-.07-1.64s-1.18-1.21-1.25-1.08.41.6.75,1.32S429.6,397.22,429.76,397.23Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '429.1877072453499px 395.85659289360046px',
          }}
          id="elw13rs7lo6bg"
          className="animable"
        />
        <path
          d="M433.33,387.82c.07.15.8-.09,1.71,0s1.62.32,1.7.18-.6-.7-1.68-.74S433.25,387.7,433.33,387.82Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '435.03518307209015px 387.65089562535286px',
          }}
          id="elbad2fgk7zc4"
          className="animable"
        />
        <path
          d="M448.43,244.45l8.24,21.86,7.51-3.3-6.06-20.14S451.91,241.63,448.43,244.45Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '456.30499267578125px 254.45425701141357px',
          }}
          id="elp7axcoltoq"
          className="animable"
        />
        <path
          d="M336.94,208.6s-3.62-.59-5.36-1.87l-10.74-8s-1.24-1.59,1.5-1.23,9.75,3.05,9.75,3.05l0-2.59.87-4.15,8.59,7.49Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '331.0550880432129px 201.20501708984375px',
          }}
          id="ely478hwzfrf"
          className="animable"
        />
        <path
          d="M360,232.42l-23-23.82,3.45-8.2,24.22,18S363,228.6,360,232.42Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '350.8350067138672px 216.41000366210938px',
          }}
          id="elw5hzevriyw"
          className="animable"
        />
        <path
          d="M464,262.54a13,13,0,0,1,1.22,1.23c.8.89,1.88,2.06,3.17,3.48.34.39.68.73,1.06,1.2a1,1,0,0,1,.07,1,1.05,1.05,0,0,1-.81.62l-1.78.36-.46.09a.93.93,0,0,1-.58-.08,1.35,1.35,0,0,0-.82,0,2.09,2.09,0,0,0-.41.17c-.13.07-.15.11-.17.2a.25.25,0,0,0,0,.12l.09.24.19.48c.25.65.5,1.3.75,2,.5,1.35,1,2.75,1.41,4.22a12,12,0,0,1,.46,2.22,1.72,1.72,0,0,1-.28,1.23.72.72,0,0,1-.73.19,1.43,1.43,0,0,1-.57-.27h0l0,0c-3.06-4-5.74-7.49-7.62-10a11.31,11.31,0,0,1-1.32-3.49,5.47,5.47,0,0,1-.21-1.33,12,12,0,0,1,.38,1.28,12.51,12.51,0,0,0,1.43,3.35l7.74,9.91-.05-.05c.24.18.57.26.63.14a1.38,1.38,0,0,0,.13-.85,10.93,10.93,0,0,0-.44-2.1c-.41-1.45-.9-2.85-1.39-4.19l-.73-2-.19-.48-.09-.24a.74.74,0,0,1,0-.37.71.71,0,0,1,.42-.56,3.07,3.07,0,0,1,.5-.2,1.8,1.8,0,0,1,1.1,0c.23.08.2.09.35.06l.46-.08,1.78-.33a.65.65,0,0,0,.49-1c-.3-.37-.68-.8-1-1.16l-3.06-3.6A10.38,10.38,0,0,1,464,262.54Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '463.14088773727417px 272.04077339172363px',
          }}
          id="elxxqqc0dbcrn"
          className="animable"
        />
        <path
          d="M393.35,180c-.54.18-5.83,3.72-7.35,6.66-.93,1.78-1.47,12.24-1.47,12.24s-3.24,6.66-2.16,11.34l1.08,4.68s.9,20,2.52,24.83a18.74,18.74,0,0,0,5,7.74s14.4-9.18,22-10.8a36.65,36.65,0,0,1,13.67-.36,14.86,14.86,0,0,0,5.4-5.58c1.62-3.41,2.34-14.21,2.34-14.21l-2.88-38.7-13.43-3.66L413,168.7l-8.25,6-4.14,10.21L399,175.84l-3.7,3.66Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '408.2647895812988px 208.09500885009766px',
          }}
          id="el8j4hppa81sx"
          className="animable"
        />
        <path
          d="M395.59,244a2.22,2.22,0,0,1-.32-.51,12.28,12.28,0,0,1-.75-1.56,23.77,23.77,0,0,1-1.55-6.16,55.36,55.36,0,0,1-.14-9.42c.17-3.53.48-7.41.94-11.47a176.44,176.44,0,0,1,3.59-20.6c.62-2.61,1.19-4.7,1.59-6.14.21-.67.37-1.22.5-1.65a2.52,2.52,0,0,1,.21-.57,3.2,3.2,0,0,1-.11.6c-.1.43-.24,1-.4,1.67-.35,1.46-.86,3.56-1.43,6.17a201.41,201.41,0,0,0-3.43,20.58c-.46,4-.78,7.91-1,11.44a57.77,57.77,0,0,0,0,9.35,25.61,25.61,0,0,0,1.36,6.13C395.23,243.21,395.63,243.94,395.59,244Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '396.17655539512634px 214.95999908447266px',
          }}
          id="elnnvbpqbkva9"
          className="animable"
        />
        <path
          d="M424.69,200.22c.15.45,19.77,38.2,19.77,38.2s1,5.7,3,6.75,12.28-2.92,12.28-2.92-.57-7-2.22-10.12-21.3-50-21.6-50.56-3.13-4-6-3.95S424.69,200.22,424.69,200.22Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '442.2149963378906px 211.48313522338867px',
          }}
          id="el9cek7mla9me"
          className="animable"
        />
        <path
          d="M402.22,193.33a1.5,1.5,0,0,1,.4-.12,10.44,10.44,0,0,1,1.17-.25,22.23,22.23,0,0,1,4.46-.28,44.74,44.74,0,0,1,14.8,3.41l.25.1-.12.25a18.31,18.31,0,0,0-1.56,5.5l0,.26,0,.21-.2,0a34.91,34.91,0,0,1-12.68-1.07,33.78,33.78,0,0,1-8.68-3.73l-.12-.07.07-.12c.67-1.26,1.22-2.28,1.64-3.05a8.67,8.67,0,0,1,.63-1.06,8.46,8.46,0,0,1-.49,1.14c-.39.78-.9,1.82-1.52,3.11l-.06-.2a36,36,0,0,0,8.65,3.54,35.16,35.16,0,0,0,12.5,1l-.23.23,0-.26a18.72,18.72,0,0,1,1.62-5.66l.14.35A46.78,46.78,0,0,0,408.24,193a26.32,26.32,0,0,0-4.42.12A15.82,15.82,0,0,1,402.22,193.33Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '411.6199951171875px 197.62261724472046px',
          }}
          id="elgf2akrwc3tt"
          className="animable"
        />
        <path
          d="M384.54,196.42a2.9,2.9,0,0,1,.86-.38,19.19,19.19,0,0,1,2.45-.67,21.43,21.43,0,0,1,3.75-.43,4.57,4.57,0,0,1,1.15.05,1.22,1.22,0,0,1,.91,1c.14.85-.2,1.7.11,2.25a.88.88,0,0,0,.12.15l.21.32-.3.11a69.3,69.3,0,0,0-7.85,3.71l-.06,0-.07,0a15,15,0,0,1-2.66-.91,17,17,0,0,1,2.75.59h-.13a50.46,50.46,0,0,1,7.83-3.9l-.08.43a1.28,1.28,0,0,1-.2-.26,2.22,2.22,0,0,1-.2-1.33,4.52,4.52,0,0,0,0-1.09.7.7,0,0,0-.54-.6,4.68,4.68,0,0,0-1-.05,24.14,24.14,0,0,0-3.69.31C385.82,196.07,384.57,196.5,384.54,196.42Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '388.6299743652344px 198.7271625995636px',
          }}
          id="elolxsrwxnyi"
          className="animable"
        />
        <path
          d="M386,186.7s-3,5.16-3.85,8.47S373.49,218,373.49,218s-3.22-1.81-3.85,1.62l-5-1.91L359.12,233s12.62,6.29,14.24,6,11.76-3.45,11.76-3.45a47.19,47.19,0,0,0,2.19-6.5c.71-3,4.5-38.66,4.5-38.66Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '375.4649963378906px 212.85486221313477px',
          }}
          id="elucw0chyl09"
          className="animable"
        />
        <path
          d="M382.86,211.8a1.13,1.13,0,0,1-.62.21,3.52,3.52,0,0,1-1.8-.22,3.56,3.56,0,0,1-2-1.85,2.31,2.31,0,0,1,0-1.68,1.54,1.54,0,0,1,1.52-1,1.63,1.63,0,0,1,1.48,1.12,1.56,1.56,0,0,1-.62,1.61,1.87,1.87,0,0,1-1.48.37,2.21,2.21,0,0,1-1.19-.56,2,2,0,0,1-.64-1.71c0-.43.19-.64.21-.62s0,.23,0,.63a1.92,1.92,0,0,0,.68,1.42,1.73,1.73,0,0,0,2.13.1,1.09,1.09,0,0,0,.43-1.11,1.15,1.15,0,0,0-1-.73,1,1,0,0,0-1,.7,1.82,1.82,0,0,0,0,1.32,3.2,3.2,0,0,0,1.67,1.69A5.07,5.07,0,0,0,382.86,211.8Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '380.17826867103577px 209.65098762512207px',
          }}
          id="elfv9bvh0rz56"
          className="animable"
        />
        <path
          d="M389.51,246a1.79,1.79,0,0,1-.48-.32,6.62,6.62,0,0,1-1.11-1.24,20.07,20.07,0,0,1-2.49-5.55,11.72,11.72,0,0,1-.45-2c-.09-.71-.12-1.43-.19-2.18-.12-1.5-.27-3.1-.44-4.78-.34-3.36-.8-7.05-1.31-10.92a63.66,63.66,0,0,1-.49-11,61.67,61.67,0,0,1,.92-9,31.89,31.89,0,0,1,1.58-5.87,13.72,13.72,0,0,1,.67-1.51,2.34,2.34,0,0,1,.28-.51c.05,0-.3.74-.75,2.09a35.4,35.4,0,0,0-1.42,5.86A67.18,67.18,0,0,0,383,208a66.13,66.13,0,0,0,.53,11c.5,3.87.95,7.56,1.27,10.94.16,1.68.29,3.29.39,4.79.06.74.08,1.48.16,2.16a11.57,11.57,0,0,0,.41,1.93,21.21,21.21,0,0,0,2.3,5.54A8.73,8.73,0,0,0,389.51,246Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '386.00182461738586px 218.56000518798828px',
          }}
          id="el8e1bltas7tv"
          className="animable"
        />
        <path
          d="M431.53,178.19a17.14,17.14,0,0,1-2,.17,12.65,12.65,0,0,0-4.54,1.38,13.36,13.36,0,0,0-3.74,3c-.81.92-1.22,1.58-1.29,1.54a5.15,5.15,0,0,1,1-1.78,11.69,11.69,0,0,1,3.77-3.18A11.33,11.33,0,0,1,429.5,178,5.12,5.12,0,0,1,431.53,178.19Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '425.7449951171875px 181.12618160247803px',
          }}
          id="el1dupedfwppv"
          className="animable"
        />
        <path
          d="M395.49,179.87c-.05-.1.94-.62,2.23-1.6l.25-.2.11.32.69,2.17a49.24,49.24,0,0,1,1.61,4.78,16.72,16.72,0,0,1-2.1-4.61c-.26-.8-.48-1.55-.65-2.21l.36.12A6.39,6.39,0,0,1,395.49,179.87Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '397.9340879917145px 181.70499420166016px',
          }}
          id="elfrmicbrdzi5"
          className="animable"
        />
        <path
          d="M373.13,229.56c-.13,0-.5-2.33-1.42-5.1a27.35,27.35,0,0,0-1.37-3.46,10.1,10.1,0,0,1-.7-1.39c.05,0,.51.38,1,1.22a16.22,16.22,0,0,1,1.54,3.47C373.15,227.12,373.29,229.55,373.13,229.56Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '371.41318249702454px 224.5849838256836px',
          }}
          id="el2ewo2iye5wn"
          className="animable"
        />
        <path
          d="M378.19,224.76c-.15.05-.76-1.72-2.1-3.56s-2.82-3-2.73-3.12a9.83,9.83,0,0,1,4.83,6.68Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '375.7730429172516px 221.42051553726196px',
          }}
          id="elaxgyurw9x89"
          className="animable"
        />
        <g id="el1wqn4awg9vp">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '382.84783458709717px 217.00499725341797px',
            }}
            className="animable"
          >
            <path
              d="M383.62,199.14c-1.45,5.91-2.89,11.55-2.92,17.64A37.81,37.81,0,0,0,385,234.87c-.23-2.85-.48-6-.85-8.88-1.43-11.07-1.62-18-.55-26.85"
              id="el5p7x4439ibu"
              style={{
                transformOrigin: '382.84783458709717px 217.00499725341797px',
              }}
              className="animable"
            />
          </g>
        </g>
        <g id="el4e70dz840gs">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '372.0689969062805px 224.47268629074097px',
            }}
            className="animable"
          >
            <path
              d="M369.77,219.59a24.09,24.09,0,0,1,3.29,4,8,8,0,0,1,1.29,4.92,1.26,1.26,0,0,1-.21.67.51.51,0,0,1-.64.15.8.8,0,0,1-.25-.48,42.85,42.85,0,0,0-3.43-9.29"
              id="el0w8giqzhcjz"
              style={{
                transformOrigin: '372.0689969062805px 224.47268629074097px',
              }}
              className="animable"
            />
          </g>
        </g>
        <g id="elg19o9xqbb0t">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '450.3759231567383px 236.14693903923035px',
            }}
            className="animable"
          >
            <path
              d="M444.46,238.42a18.13,18.13,0,0,1,4.91-2.48,19.33,19.33,0,0,1,5.85-.47,1.21,1.21,0,0,0,.79-.24.68.68,0,0,0,.32-.71c-.1-.37-.54-.5-.92-.55a12.15,12.15,0,0,0-11,4.45"
              id="elvj9s685qtz"
              style={{
                transformOrigin: '450.3759231567383px 236.14693903923035px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M456.9,235.76c0,.19-3-.58-6.49.18a20.54,20.54,0,0,0-5.93,2.56,4.9,4.9,0,0,1,1.48-1.27,12.68,12.68,0,0,1,4.35-1.8,13.9,13.9,0,0,1,4.7-.16A5.67,5.67,0,0,1,456.9,235.76Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '450.6900177001953px 236.8208520412445px',
          }}
          id="elusvs4y7naf"
          className="animable"
        />
        <path
          d="M395.44,214.45a1.44,1.44,0,0,1-.33.26,4.19,4.19,0,0,1-1.13.47,4.63,4.63,0,0,1-2,0,4.52,4.52,0,0,1-2.3-1.17,4.35,4.35,0,0,1-1.24-2.88,4.58,4.58,0,0,1,1.18-3.4,2.5,2.5,0,0,1,.81-.62,1.47,1.47,0,0,1,1.12-.12,1.09,1.09,0,0,1,.72,1,1.49,1.49,0,0,1-.36,1.11,3.56,3.56,0,0,1-1.95,1,5.11,5.11,0,0,1-2.2,0,5.67,5.67,0,0,1-3.52-2.4,4.16,4.16,0,0,1-.45-3.94,2.62,2.62,0,0,1,1.41-1.33,2,2,0,0,1,1.83.17,2.7,2.7,0,0,1,1.17,2.87,4.15,4.15,0,0,1-1.36,2.21,6.94,6.94,0,0,1-1.63,1,10.06,10.06,0,0,1-1.11.47c-.26.1-.4.14-.41.12s.52-.27,1.43-.77a7.37,7.37,0,0,0,1.53-1.08,3.94,3.94,0,0,0,1.19-2.06,2.33,2.33,0,0,0-1-2.43,1.61,1.61,0,0,0-1.45-.11,2.17,2.17,0,0,0-1.14,1.11,3.77,3.77,0,0,0,.44,3.46,5.28,5.28,0,0,0,3.21,2.17,5,5,0,0,0,2,0,3.2,3.2,0,0,0,1.66-.83c.38-.4.32-1.14-.13-1.27a1.51,1.51,0,0,0-1.42.6,4.2,4.2,0,0,0-1.1,3.05,4,4,0,0,0,1.07,2.64,4.5,4.5,0,0,0,3.95,1.19A7.23,7.23,0,0,0,395.44,214.45Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '389.46423292160034px 208.78651332855225px',
          }}
          id="elewocewifwf"
          className="animable"
        />
        <path
          d="M426.69,203.67a13.94,13.94,0,0,0-3.21,2.08,11.62,11.62,0,0,0-2.7,3.55,11.23,11.23,0,0,0-.92,2.62,6.25,6.25,0,0,0-.05,3,1.3,1.3,0,0,0,1.07.93,1.54,1.54,0,0,0,1.39-.6,6,6,0,0,0,.69-3.5,7.07,7.07,0,0,0-12.62-3.87,7.36,7.36,0,0,0-1.1,2.05,2.36,2.36,0,0,0-.19,1.08,1.54,1.54,0,0,0,.45.94,1.74,1.74,0,0,0,2,.35,3.86,3.86,0,0,0,1.38-1.86,7.17,7.17,0,0,0,.1-4.75,9.22,9.22,0,0,0-2.48-4,7.89,7.89,0,0,0-4-2.09,6.22,6.22,0,0,0-4.2.71,5.51,5.51,0,0,0-2.6,3.07,4.23,4.23,0,0,0,.48,3.68,3.06,3.06,0,0,0,3.12,1.2,2.47,2.47,0,0,0,1.88-2.35,3.05,3.05,0,0,0-1.2-2.62,3.94,3.94,0,0,0-2.54-.82,5.86,5.86,0,0,0-4,1.73,9.79,9.79,0,0,0-1.55,2.37l-.35.65a.83.83,0,0,1-.14.22s0-.09.09-.24.18-.41.31-.68a8.59,8.59,0,0,1,1.5-2.46,6,6,0,0,1,4.1-1.88,4.18,4.18,0,0,1,2.75.85,3.41,3.41,0,0,1,1.36,2.9,3.22,3.22,0,0,1-.59,1.69,2.58,2.58,0,0,1-1.57,1,3.47,3.47,0,0,1-3.56-1.34,4.69,4.69,0,0,1-.57-4.07,6,6,0,0,1,2.81-3.35,6.64,6.64,0,0,1,4.52-.78,8.33,8.33,0,0,1,4.25,2.21,9.67,9.67,0,0,1,2.62,4.2,7.64,7.64,0,0,1-.11,5.1,6.19,6.19,0,0,1-.63,1.16,2.69,2.69,0,0,1-1,1,2.23,2.23,0,0,1-2.6-.45,2.05,2.05,0,0,1-.6-1.24,3.09,3.09,0,0,1,.22-1.31,8,8,0,0,1,1.18-2.19,7.22,7.22,0,0,1,4-2.62,7.87,7.87,0,0,1,4.59.22,7.16,7.16,0,0,1,3.45,2.67,8,8,0,0,1,1.41,3.88,6.25,6.25,0,0,1-.81,3.78,1.9,1.9,0,0,1-1.75.73,1.69,1.69,0,0,1-.88-.4,1.94,1.94,0,0,1-.49-.79,4,4,0,0,1-.16-1.68,12.85,12.85,0,0,1,.24-1.55,11.45,11.45,0,0,1,1-2.68,11.83,11.83,0,0,1,2.82-3.57,10.58,10.58,0,0,1,2.42-1.57,5.23,5.23,0,0,1,.69-.28Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '411.0449981689453px 207.6029634475708px',
          }}
          id="elwa3ukyvetr"
          className="animable"
        />
        <path
          d="M443.83,201.11a2,2,0,0,1-.11.61,3.91,3.91,0,0,1-.92,1.52,4.58,4.58,0,0,1-6.08.44,6,6,0,0,1-2.42-3.79,8,8,0,0,1,.82-5.1,4.11,4.11,0,0,1,2-2.06,1.62,1.62,0,0,1,1.6.17,1.85,1.85,0,0,1,.68,1.48,3.31,3.31,0,0,1-1.75,2.57,8.1,8.1,0,0,1-2.94,1.17,8.55,8.55,0,0,1-6-1.18,6.06,6.06,0,0,1-2.06-2.15,3.88,3.88,0,0,1-.48-2.84,2.52,2.52,0,0,1,2.05-1.81,3.09,3.09,0,0,1,2.51.67,3.39,3.39,0,0,1,1.09,2.16,4.12,4.12,0,0,1-.35,2.19,5.29,5.29,0,0,1-2.74,2.5,7.84,7.84,0,0,1-2.75.59,10.68,10.68,0,0,1-1.76-.07,2.19,2.19,0,0,1-.61-.1c0-.05.85.07,2.36,0a7.75,7.75,0,0,0,2.64-.64,5,5,0,0,0,2.52-2.4,3.36,3.36,0,0,0-.68-3.86,2.64,2.64,0,0,0-2.15-.55,2,2,0,0,0-1.67,1.49,3.44,3.44,0,0,0,.45,2.47,5.68,5.68,0,0,0,1.91,2,8,8,0,0,0,5.64,1.09,7.46,7.46,0,0,0,2.74-1.08,2.81,2.81,0,0,0,1.53-2.14,1.35,1.35,0,0,0-.47-1.08,1.14,1.14,0,0,0-1.12-.11,3.59,3.59,0,0,0-1.76,1.82,7.52,7.52,0,0,0-.82,4.8,5.63,5.63,0,0,0,2.21,3.57,4.41,4.41,0,0,0,3.33.89,4.57,4.57,0,0,0,2.39-1.18A4.49,4.49,0,0,0,443.83,201.11Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '433.71998596191406px 197.36215829849243px',
          }}
          id="elx7e79x039jp"
          className="animable"
        />
        <g id="el3k6yecwjmok">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '427.0500030517578px 205.56000518798828px',
            }}
            className="animable"
          >
            <path
              d="M420.5,192.41c.76,5,1.53,10.13,3.45,14.85s5.12,9.11,9.65,11.45q-5.85-13.2-12.52-26"
              id="elzm4ggtcsvbm"
              style={{
                transformOrigin: '427.0500030517578px 205.56000518798828px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M434.38,219.61a5.51,5.51,0,0,1-.63-1l-1.57-2.95c-1.3-2.5-3.07-6-5-9.8s-3.64-7.34-4.86-9.87l-1.42-3a6.59,6.59,0,0,1-.46-1.14,4.65,4.65,0,0,1,.64,1l1.57,2.95c1.3,2.49,3.07,6,5,9.8s3.64,7.34,4.86,9.88l1.42,3A5.25,5.25,0,0,1,434.38,219.61Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '427.41001892089844px 205.73001098632812px',
          }}
          id="ellu9nnzryfl"
          className="animable"
        />
        <path
          d="M418.31,174.64a5.4,5.4,0,0,1-.71.48c-.47.32-1.16.78-2,1.46s-1.76,1.6-2.88,2.65a21.79,21.79,0,0,1-4.19,3.15l-.16.09-.09-.16c-1.21-2.19-2.33-4.79-3.78-7.49l.4,0c-2.44,6.39-6.06,13.81-7.86,22.39a65.06,65.06,0,0,0-1.3,17.22,70.56,70.56,0,0,0,2.39,13.93c1,3.9,2.24,6.95,3,9.07l1,2.41.24.63c.05.15.07.22.06.23a70.83,70.83,0,0,1-4.65-12.24,68.81,68.81,0,0,1-2.51-14,64.38,64.38,0,0,1,1.27-17.36A76.38,76.38,0,0,1,400.28,185l4.22-10.35.18-.44.22.41c1.44,2.74,2.53,5.34,3.71,7.53l-.25-.07c3.38-1.86,5.38-4.37,7.13-5.64A14.82,14.82,0,0,1,418.31,174.64Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '406.7270040512085px 207.45499420166016px',
          }}
          id="elfltoil37eqe"
          className="animable"
        />
        <path
          d="M391,247.53l6.18,22.77,6.74,46.5s15.56,47.64,17.14,51.7,7.77,16.94,7.77,16.94l18.59-6.2s-5.12-21.68-7.41-29.79a102,102,0,0,0-6.7-16.57l-6.17-39.14L426.8,259l-1.41-23.42S408.8,230.94,391,247.53Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '419.2099914550781px 310.2114715576172px',
          }}
          id="el0tlh3baztabq"
          className="animable"
        />
        <path
          d="M400.41,363.46s-6.77-21.95-9.4-32.35-5.08-17.42-5.08-17.42,2.45-2.1,4.21-3.49,22.91-15.4,22.91-15.4S435.91,283,437.73,271c1.76-11.63.18-15.76-4.76-23.66a114.15,114.15,0,0,1-6.33-11l-1.25-.78-19.21,13.16-1.45,13.72S374.5,286.68,370.45,292s-10.36,14.11-7.19,24.52,14.84,51.87,14.84,51.87Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '400.41223526000977px 301.97499084472656px',
          }}
          id="el1t18sy98vd1"
          className="animable"
        />
        <path
          d="M385.7,314.25a13.23,13.23,0,0,0-4.3-2.23,13,13,0,0,0-4.84,0,3,3,0,0,1,1.38-.54,8.06,8.06,0,0,1,6.79,1.69C385.44,313.73,385.75,314.22,385.7,314.25Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '381.13263177871704px 312.7805165052414px',
          }}
          id="el7osod1y2h6c"
          className="animable"
        />
        <path
          d="M429.78,281.64c.08.12-9.67,7.32-21.79,16.09s-22,15.77-22.1,15.66,9.67-7.32,21.79-16.09S429.7,281.53,429.78,281.64Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '407.83485412597656px 297.51501178741455px',
          }}
          id="elsdjhzdeini"
          className="animable"
        />
        <path
          d="M406.43,262.12a43.19,43.19,0,0,1-5.06,4.21,40.26,40.26,0,0,1-5.38,3.79,43.06,43.06,0,0,1,5.06-4.21A41,41,0,0,1,406.43,262.12Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '401.2099914550781px 266.1199951171875px',
          }}
          id="elvoew41whxm"
          className="animable"
        />
        <path
          d="M403,262.87a13.87,13.87,0,0,1-1.55-2.54,59.67,59.67,0,0,1-3-6.53,58.16,58.16,0,0,1-2.15-6.84,13.66,13.66,0,0,1-.54-2.92,21.68,21.68,0,0,1,.9,2.82c.52,1.75,1.28,4.16,2.27,6.76s2,4.89,2.8,6.55A22.56,22.56,0,0,1,403,262.87Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '399.37998962402344px 253.45498657226562px',
          }}
          id="el72380tnqad5"
          className="animable"
        />
        <path
          d="M291.75,326.61l4.65,14.62s-13.29,9.63-12.69,12.42l28.66-8-6.32-23.07Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '298.0301399230957px 338.114990234375px',
          }}
          id="elrwxq9gvl2l"
          className="animable"
        />
        <path
          d="M304.92,337.51a1.23,1.23,0,0,1,1.18,1.11A1.16,1.16,0,0,1,305,339.8a1.28,1.28,0,0,1-1.25-1.18,1.22,1.22,0,0,1,1.27-1.1"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '304.92509031295776px 338.6549987792969px',
          }}
          id="el0g7u62fu1umt"
          className="animable"
        />
        <path
          d="M312.55,346.24,312,344l-27.52,7.87s-1.12.91-.72,1.77Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '298.111852645874px 348.8199920654297px',
          }}
          id="eltzby97f29fp"
          className="animable"
        />
        <path
          d="M295.9,341.21c0,.14.76,0,1.57.27s1.35.74,1.46.65-.32-.84-1.31-1.14S295.83,341.09,295.9,341.21Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '297.4212462902069px 341.51095992326736px',
          }}
          id="elicq4dj9s2u"
          className="animable"
        />
        <path
          d="M293.24,343.29c0,.15.68.22,1.32.68s.95,1,1.09,1,0-.86-.8-1.42S293.2,343.16,293.24,343.29Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '294.46817648410797px 344.0650414824486px',
          }}
          id="el6h3yai5m5ds"
          className="animable"
        />
        <path
          d="M292.53,347.37c.14,0,.14-.76-.43-1.43s-1.32-.79-1.34-.65.49.43.95,1S292.39,347.39,292.53,347.37Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '291.6834194660187px 346.30433320999146px',
          }}
          id="el3fq552mou2m"
          className="animable"
        />
        <path
          d="M295.21,337.76c.09.11.68-.26,1.49-.43s1.49-.09,1.53-.23-.7-.47-1.64-.26S295.11,337.67,295.21,337.76Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '296.71483838558197px 337.27599596977234px',
          }}
          id="elei74u1mwoz"
          className="animable"
        />
        <path
          d="M234.2,300.2,244,317s-16.91,6.58-17,9.73l32.93.15,0-2.56-7.29-24.43Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '243.46499633789062px 313.385009765625px',
          }}
          id="elvagidffw92q"
          className="animable"
        />
        <path
          d="M254.1,315.38a1.35,1.35,0,0,1,1,1.52,1.29,1.29,0,0,1-1.5,1,1.41,1.41,0,0,1-1-1.61,1.32,1.32,0,0,1,1.66-.82"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '253.84680318832397px 316.6511913537979px',
          }}
          id="eltzjyywwfyz"
          className="animable"
        />
        <path
          d="M259.83,326.85l0-2.56-31.63.72s-1.45.66-1.27,1.69Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '243.37224578857422px 325.57000732421875px',
          }}
          id="el5u41c3q22ps"
          className="animable"
        />
        <path
          d="M244,316.81c0,.16.81.22,1.61.72s1.23,1.17,1.38,1.11-.11-1-1.09-1.58S244,316.66,244,316.81Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '245.5147215127945px 317.65218245983124px',
          }}
          id="ellacyd8ti6t"
          className="animable"
        />
        <path
          d="M240.31,318.53c0,.16.66.42,1.22,1.09s.73,1.39.89,1.38.24-.92-.46-1.74S240.31,318.38,240.31,318.53Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '241.4196698665619px 319.732675075531px',
          }}
          id="elee1egbrzvv8"
          className="animable"
        />
        <path
          d="M238.36,322.73c.15,0,.36-.77-.07-1.65s-1.18-1.21-1.25-1.07.41.6.75,1.32S238.2,322.72,238.36,322.73Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '237.78932970762253px 321.3545105457306px',
          }}
          id="el8bmquet20b"
          className="animable"
        />
        <path
          d="M241.93,313.32c.07.14.8-.09,1.71,0s1.62.32,1.71.18-.61-.7-1.68-.74S241.85,313.19,241.93,313.32Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '243.64096057415009px 313.1508578658104px',
          }}
          id="elr1yle9ifg3j"
          className="animable"
        />
        <path
          d="M248.91,53.13l.79-.05C258.27,53,263.11,60.24,263,68.8l2.13,34.53-14.89,14-5.7-7.07-.4-7.39-.33-6.2s-8.28-.72-8.93-8.91c-.32-4-.3-12.15-.2-19.57A15.31,15.31,0,0,1,248.91,53.13Z"
          style={{
            fill: 'rgb(153, 105, 100)',
            transformOrigin: '249.8724594116211px 85.20467376708984px',
          }}
          id="el3vlc7s61p7h"
          className="animable"
        />
        <path
          d="M243.75,96.69a19.15,19.15,0,0,0,10.49-3.76s-2.13,6.07-10.36,5.88Z"
          style={{
            fill: 'rgb(120, 77, 72)',
            transformOrigin: '248.99501037597656px 95.87218356132507px',
          }}
          id="ell5ei4ucn7w"
          className="animable"
        />
        <path
          d="M236.74,74a1.17,1.17,0,0,0,1.2,1.11A1.13,1.13,0,0,0,239.08,74a1.18,1.18,0,0,0-1.21-1.11A1.12,1.12,0,0,0,236.74,74Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '237.91000366210938px 73.99999928474426px',
          }}
          id="elvy7yk3hidck"
          className="animable"
        />
        <path
          d="M236.51,71.67c.15.15,1-.57,2.26-.65s2.22.49,2.35.32-.11-.34-.53-.6a3.21,3.21,0,0,0-3.68.26C236.54,71.32,236.43,71.61,236.51,71.67Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '238.82035756111145px 70.98551452159882px',
          }}
          id="el6jrd758ryrd"
          className="animable"
        />
        <path
          d="M248.31,73.18a1.18,1.18,0,0,0,1.21,1.11,1.12,1.12,0,0,0,1.13-1.14,1.18,1.18,0,0,0-1.2-1.11A1.13,1.13,0,0,0,248.31,73.18Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '249.4800775051117px 73.1651177406311px',
          }}
          id="el0werdxufacmk"
          className="animable"
        />
        <path
          d="M248.61,70.52c.14.15,1-.47,2.31-.41s2.16.73,2.31.58-.07-.35-.46-.66a3.23,3.23,0,0,0-1.84-.65,3.09,3.09,0,0,0-1.85.51C248.68,70.17,248.54,70.44,248.61,70.52Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '250.935076713562px 70.04421657323837px',
          }}
          id="el06o959hw4ht"
          className="animable"
        />
        <path
          d="M245.11,81.15a8.12,8.12,0,0,0-2.07-.23c-.32,0-.63-.06-.7-.27a1.66,1.66,0,0,1,.15-1c.25-.8.51-1.64.79-2.52a40.19,40.19,0,0,0,1.7-6.55,43.81,43.81,0,0,0-2.23,6.4c-.26.88-.5,1.72-.74,2.53a1.82,1.82,0,0,0-.08,1.27.82.82,0,0,0,.56.44,2.14,2.14,0,0,0,.55,0A8.1,8.1,0,0,0,245.11,81.15Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '243.48086559772491px 75.91803026199341px',
          }}
          id="elx5ufr69lgb"
          className="animable"
        />
        <path
          d="M248.52,66c.14.33,1.39.09,2.88.16s2.71.41,2.89.09c.08-.16-.15-.46-.66-.76a4.94,4.94,0,0,0-4.39-.19C248.71,65.59,248.45,65.88,248.52,66Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '251.40717148780823px 65.630215883255px',
          }}
          id="elxm05mec2eq"
          className="animable"
        />
        <path
          d="M236.6,68.15c.24.27,1.09-.08,2.13-.16s1.94.06,2.12-.25c.08-.16-.08-.43-.48-.68a3,3,0,0,0-1.77-.35,2.93,2.93,0,0,0-1.66.69C236.59,67.72,236.49,68,236.6,68.15Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '238.7137417793274px 67.4712079167366px',
          }}
          id="elgd25hshk2fk"
          className="animable"
        />
        <path
          d="M262.69,74.91c.13-.07,5.52-2,5.71,3.58s-5.48,4.65-5.49,4.49S262.69,74.91,262.69,74.91Z"
          style={{
            fill: 'rgb(153, 105, 100)',
            transformOrigin: '265.5473334789276px 78.83374691009521px',
          }}
          id="elwc2ionz7thp"
          className="animable"
        />
        <path
          d="M264.55,80.79s.1.07.27.14a1,1,0,0,0,.73,0,2.43,2.43,0,0,0,1-2.21,3.23,3.23,0,0,0-.32-1.39,1.13,1.13,0,0,0-.76-.73.5.5,0,0,0-.57.29c-.07.16,0,.27-.06.28s-.12-.09-.09-.32a.59.59,0,0,1,.21-.36.75.75,0,0,1,.54-.17,1.38,1.38,0,0,1,1,.84A3.27,3.27,0,0,1,267,78.7a2.52,2.52,0,0,1-1.34,2.48,1,1,0,0,1-.9-.12C264.56,80.93,264.53,80.8,264.55,80.79Z"
          style={{
            fill: 'rgb(120, 77, 72)',
            transformOrigin: '265.7784411907196px 78.77714228630066px',
          }}
          id="el1426irhj22sh"
          className="animable"
        />
        <path
          d="M233.08,58.7a2.85,2.85,0,0,1,2-2.43A2.56,2.56,0,0,1,238.86,53a2.64,2.64,0,0,1,3.42-2.58A2.21,2.21,0,0,1,246.33,49a3.82,3.82,0,0,1,5.9-.89,4.88,4.88,0,0,1,6.09,2.22,4.63,4.63,0,0,1,4.29,2.9,3.39,3.39,0,0,1,2.85,5.12,2.51,2.51,0,0,1,.79,3.92,2.54,2.54,0,0,1,1.52,2.15,2.51,2.51,0,0,1-1.29,2.3c.83,0,1.24,1.12,1,1.93a21.89,21.89,0,0,1-1,2.27c-.22.65-.25,1.35-.44,2a4.47,4.47,0,0,1-2.47,2.82l.16.16c.2.71-.77,1.27-1.47,1a3.67,3.67,0,0,1-1.55-1.5,8.13,8.13,0,0,1-1.33-2.14A2,2,0,0,1,260,71a2.91,2.91,0,0,1-1.93-2.19,8.62,8.62,0,0,1,0-3c.17-1.5.33-3,.5-4.5a5.63,5.63,0,0,1-5.05-2.85,3.21,3.21,0,0,1-4.73-.83,4.19,4.19,0,0,1-4.91,2.92c.3,1.15-1.71,2.37-2.83,2.75a4.13,4.13,0,0,1-2.6-.33s-1.89,1.3-3,.94-2.6-1.6-2-2.76A5.17,5.17,0,0,1,233.08,58.7Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '250.41517066955566px 62.0316047668457px',
          }}
          id="elz9w22d5dp4"
          className="animable"
        />
        <path
          d="M266.53,62.21c-.06,0-.06.39-.51.76a1,1,0,0,1-.9.22,1.11,1.11,0,0,1-.84-.77l-.09-.33-.24.25a1.54,1.54,0,0,1-1.53.34,1.51,1.51,0,0,1-1-1.43l0-.33-.3.15a1.46,1.46,0,0,1-1.86-.49,3.39,3.39,0,0,1-.34-.8s-.15.36.14.92a1.65,1.65,0,0,0,.81.74,1.8,1.8,0,0,0,1.42,0l-.28-.19a1.84,1.84,0,0,0,3.17,1.38l-.33-.08a1.45,1.45,0,0,0,1.16,1,1.33,1.33,0,0,0,1.13-.37C266.66,62.64,266.56,62.18,266.53,62.21Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '262.7195153236389px 61.67217206954956px',
          }}
          id="el4tsqyjn3h5q"
          className="animable"
        />
        <path
          d="M267.74,67.52a3.14,3.14,0,0,1-.59.27,1.32,1.32,0,0,1-1.44-.5l-.13-.19-.14.18a1.53,1.53,0,0,1-1.4.5,1.47,1.47,0,0,1-1.14-1.24l0-.37-.3.22a.77.77,0,0,1-.25.14,1,1,0,0,1-1.16-.3,1.1,1.1,0,0,1-.12-1.11l.19-.37-.39.09a1.78,1.78,0,0,1-1.32-.23,1.75,1.75,0,0,1-.69-.81,3.89,3.89,0,0,1-.19-1,1.28,1.28,0,0,0,0,1.05,1.94,1.94,0,0,0,.73,1,2,2,0,0,0,1.56.33l-.2-.27a1.42,1.42,0,0,0,1.76,2,1.58,1.58,0,0,0,.36-.2l-.34-.14a1.8,1.8,0,0,0,3.22.89h-.27a1.42,1.42,0,0,0,1,.58,1.53,1.53,0,0,0,.82-.08C267.65,67.79,267.76,67.53,267.74,67.52Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '263.14980030059814px 65.48428773880005px',
          }}
          id="elbffy34lf4dh"
          className="animable"
        />
        <path
          d="M243,50.24a2.08,2.08,0,0,1,.61-.41,1.2,1.2,0,0,1,.82,0,1.22,1.22,0,0,1,.73.77l.1.31.15-.3a2.06,2.06,0,0,1,1.66-1.08,2,2,0,0,1,2,1.28l.13.36.21-.32a2.49,2.49,0,0,1,1.88-1.06,2.37,2.37,0,0,1,2.06,1,2.47,2.47,0,0,1,.42.88l.05.22.22-.07a2.4,2.4,0,0,1,2.75,1.07,2.44,2.44,0,0,1-.21,2.65l-.2.24.31,0a2.61,2.61,0,0,1,1.75,1A2.54,2.54,0,0,1,259,58.2a4.38,4.38,0,0,1-.2,1.38s.09-.1.19-.33a2.45,2.45,0,0,0,.2-1.06,2.67,2.67,0,0,0-.54-1.61,2.89,2.89,0,0,0-1.93-1.13l.11.28a2.82,2.82,0,0,0,.3-3.06,2.78,2.78,0,0,0-3.23-1.28l.27.16a2.89,2.89,0,0,0-.49-1,2.82,2.82,0,0,0-2.43-1.14A2.89,2.89,0,0,0,249,50.63l.34,0a2.28,2.28,0,0,0-4.21-.18l.25,0a1.41,1.41,0,0,0-.93-.88,1.27,1.27,0,0,0-.94.07,1.33,1.33,0,0,0-.46.36C243,50.17,243,50.23,243,50.24Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '251.09577178955078px 54.35527563095093px',
          }}
          id="elr2een5qdvg"
          className="animable"
        />
        <path
          d="M248.88,81.77c-.21,0-.12,1.37-1.22,2.42s-2.57,1-2.57,1.19.34.24,1,.22a3.45,3.45,0,0,0,2.15-.92,3,3,0,0,0,.93-2C249.15,82.09,249,81.76,248.88,81.77Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '247.12998962402344px 83.6869364976883px',
          }}
          id="el8kz0mml0tdt"
          className="animable"
        />
        <path
          d="M331.74,199.75l2.22-10.6s-7.82-5.39-12.32-5.39h0l-9,6.51s1.94,9.4,4.28,10.38c.57.23,1.47,1.37,3.52.85A90.89,90.89,0,0,1,331.74,199.75Z"
          style={{
            fill: 'rgb(153, 105, 100)',
            transformOrigin: '323.29998779296875px 192.69722270965576px',
          }}
          id="elcjz6gudyahm"
          className="animable"
        />
        <path
          d="M312.67,190.24S302.57,174,301.4,168.91c0,0-.42-5.27,11.2-2.51l9,17.36"
          style={{
            fill: 'rgb(153, 105, 100)',
            transformOrigin: '311.49903202056885px 177.92016124725342px',
          }}
          id="el2tzyteyhy2f"
          className="animable"
        />
        <path
          d="M330.66,199.5a1.47,1.47,0,0,1-.22-.79,6.07,6.07,0,0,1,.32-2.25,6.5,6.5,0,0,0,.43-3.24,1.92,1.92,0,0,0-1.08-1.41,1.3,1.3,0,0,0-1.63.54l-.17.44-.27-.4a1.62,1.62,0,0,0-2.88.45l-.3,1-.21-1.09v-.09a1.51,1.51,0,0,0-2-.85,3,3,0,0,0-1.52,1.92l-.09.31-.27-.18a1.69,1.69,0,0,0-1.67,0,2.37,2.37,0,0,0-1.12,1.2,7.65,7.65,0,0,0-.47,2.85,5.35,5.35,0,0,1-.44,2.62,5.54,5.54,0,0,1,.09-.69,13.15,13.15,0,0,0,.06-1.93,7.23,7.23,0,0,1,.39-3,2.83,2.83,0,0,1,1.28-1.44,2.12,2.12,0,0,1,2.14,0l-.36.13a3.5,3.5,0,0,1,1.78-2.25,2.09,2.09,0,0,1,1.61,0,1.76,1.76,0,0,1,1.14,1.24l0,.15-.51-.05a2.12,2.12,0,0,1,3.8-.57l-.44,0a1.54,1.54,0,0,1,1-.85,2,2,0,0,1,1.24.06,2.36,2.36,0,0,1,1.33,1.75,6.64,6.64,0,0,1-.55,3.44,6.75,6.75,0,0,0-.46,2.14C330.6,199.22,330.69,199.49,330.66,199.5Z"
          style={{
            fill: 'rgb(120, 77, 72)',
            transformOrigin: '324.3639750480652px 195.85060834884644px',
          }}
          id="elqg3bbf6bvp"
          className="animable"
        />
        <path
          d="M320.4,201.5c-.15,0,.17-1.81.28-4s0-4,.14-4a9.58,9.58,0,0,1,.38,4A9.73,9.73,0,0,1,320.4,201.5Z"
          style={{
            fill: 'rgb(120, 77, 72)',
            transformOrigin: '320.8128381073475px 197.5px',
          }}
          id="el59itd7j3r2"
          className="animable"
        />
        <path
          d="M324.79,192.78a12.72,12.72,0,0,1-.47,8.11c-.14,0,.26-1.82.38-4S324.64,192.8,324.79,192.78Z"
          style={{
            fill: 'rgb(120, 77, 72)',
            transformOrigin: '324.76588839292526px 196.83499908447266px',
          }}
          id="el6cc9o9auq2a"
          className="animable"
        />
        <path
          d="M328.25,192.21a8.92,8.92,0,0,1,.19,3.93,8.78,8.78,0,0,1-1.08,3.79c-.14-.05.32-1.73.56-3.85S328.1,192.22,328.25,192.21Z"
          style={{
            fill: 'rgb(120, 77, 72)',
            transformOrigin: '327.95440036058426px 196.07000732421875px',
          }}
          id="ele169vrkk8i5"
          className="animable"
        />
        <path
          d="M329.6,191.44c-.05,0-.34-.29-.8-.89l.2.07a7.94,7.94,0,0,1-3.9.48,8.12,8.12,0,0,1-3.41-1.23c-.79-.51-1.16-1-1.12-1a13.42,13.42,0,0,0,4.6,1.71,9.44,9.44,0,0,0,3.72-.28l.13,0,.06.1C329.46,191,329.66,191.4,329.6,191.44Z"
          style={{
            fill: 'rgb(120, 77, 72)',
            transformOrigin: '325.0888104438782px 190.1550064086914px',
          }}
          id="elfmtzxghgpq5"
          className="animable"
        />
        <path
          d="M304.66,300.35c-3.49-18.4-12.78-34-13-35.25s-3.45-17.16-3.45-17.16,3.9-41.13,3-48.29-59.09-6.06-59.09-6.06-16.51,53.65-15.43,63.3S237.91,314,237.91,314l18.79-.14-16-57.8,16.22-43s3.68,28.42,5.58,35.68c2.15,8.23,7.95,29.16,11.35,35.5s7.4,11.14,8.56,18.32,9.66,36.55,9.66,36.55l18.28-3.85S308.32,319.67,304.66,300.35Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '263.49462127685547px 266.3196029663086px',
          }}
          id="eldi5nrhwas0l"
          className="animable"
        />
        <path
          d="M258.73,226.21a17.7,17.7,0,0,1-.66-3.33c-.31-2.08-.66-5-1-8.14s-.55-6.08-.68-8.17a21.37,21.37,0,0,1-.11-3.4,23.37,23.37,0,0,1,.47,3.37l.84,8.15c.31,3.1.6,5.91.82,8.14A28.57,28.57,0,0,1,258.73,226.21Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '257.49306416511536px 214.69001007080078px',
          }}
          id="elgp7zz3friy"
          className="animable"
        />
        <path
          d="M288,207.45a4.61,4.61,0,0,1-1.91,0,11.29,11.29,0,0,1-7.53-5,4.54,4.54,0,0,1-.78-1.75,14.27,14.27,0,0,1,1.08,1.54,13.2,13.2,0,0,0,3.23,3.09A13,13,0,0,0,286.2,207,14.31,14.31,0,0,1,288,207.45Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '282.88999938964844px 204.12500286102295px',
          }}
          id="elqlukbomdin"
          className="animable"
        />
        <path
          d="M241.94,199.26c.05,0-.33.58-1.14,1.28A11,11,0,0,1,233,203a4,4,0,0,1-1.68-.38A18,18,0,0,0,237,202,18.34,18.34,0,0,0,241.94,199.26Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '236.63218545913696px 201.1456322669983px',
          }}
          id="el2q6zdr2pmjb"
          className="animable"
        />
        <path
          d="M240.57,255.25c0,.15-1.69-.25-3.75-.24s-3.72.39-3.76.24a9.66,9.66,0,0,1,7.51,0Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '236.81501007080078px 254.8876547217369px',
          }}
          id="el31yenk28i62"
          className="animable"
        />
        <path
          d="M291.17,184.3c-1.4-7.81-2.76-13.45-2.76-13.45L285,149.55l-2.33-46.37L265,97.44s-8.42,6.49-13.51,6.78a10,10,0,0,1-7.71-2.54l-11,6.35-4.31,9.79,4,46.77s1.51,27.68-1.09,30.5c0,0,0,0,0,0,.71.43,14.94,2.37,24.55,3.43,7.14.78,19.64,0,26.06-.46,2.71-.2,6.72,2.41,10.27,3.53h0l-.65-13.19A30.47,30.47,0,0,0,291.17,184.3Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '260.36500549316406px 149.5149917602539px',
          }}
          id="elrkwi0ipxnz"
          className="animable"
        />
        <path
          d="M304.72,149.54c-.22-1.08-10.86-33.8-11.88-35.75-3.06-5.86-10.22-10.61-10.22-10.61-9.32,3.56-5.79,23.89-5.79,23.89l7.38,20.61,7.33,17.72,18,24c5.57-3.29,13.22-6.88,13.22-6.88Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '299.4671096801758px 146.2899932861328px',
          }}
          id="elrospcordlc"
          className="animable"
        />
        <path
          d="M198.51,141.55l-7.91-4.64-11.72-.43s-.47,1.52,1.88,2.44a29.55,29.55,0,0,0,6.64,1.25s-1.71-.22,1.83,2.77a13.63,13.63,0,0,0,8.17,2.91Z"
          style={{
            fill: 'rgb(153, 105, 100)',
            transformOrigin: '188.6758155822754px 141.16502380371094px',
          }}
          id="el7alwnvycabc"
          className="animable"
        />
        <path
          d="M179.85,137.16s-3.92.55-4.93,1.5-.55,1.63-.25,1.94,2.31.13,2.87-.17a21.91,21.91,0,0,1,3.7-.63s-3.68,1.44-4.05,2.58,1.23,1.85,1.23,1.85-1,1.67-.37,2.53a2,2,0,0,0,1.31.93s-1,1.14-.13,2,4.15.21,4.15.21,1.89.72,2.75.36,11.17-.82,11.17-.82l.95-6.88-15.6-4.76Z"
          style={{
            fill: 'rgb(153, 105, 100)',
            transformOrigin: '186.2753438949585px 143.76040697097778px',
          }}
          id="elcf1ejpambp5"
          className="animable"
        />
        <path
          d="M182.27,143.11c-.14-.06,0-.62,0-1.3s-.05-1.24.09-1.28.46.52.43,1.3S182.39,143.16,182.27,143.11Z"
          style={{
            fill: 'rgb(120, 77, 72)',
            transformOrigin: '182.4998715221882px 141.82056868076324px',
          }}
          id="els809b7twfy"
          className="animable"
        />
        <path
          d="M178.42,144.23c0-.08.33-.12.81-.22a2.14,2.14,0,0,0,.76-.31,1.15,1.15,0,0,0,.51-.71.94.94,0,0,0-.32-.78,1.89,1.89,0,0,0-.7-.39c-.47-.16-.8-.23-.79-.31s.33-.12.88,0a2,2,0,0,1,.93.39,1.34,1.34,0,0,1,.51,1.21,1.5,1.5,0,0,1-.76,1.05,2.08,2.08,0,0,1-1,.26C178.73,144.38,178.42,144.29,178.42,144.23Z"
          style={{
            fill: 'rgb(120, 77, 72)',
            transformOrigin: '179.7192748785019px 142.9271341562271px',
          }}
          id="elq4stbcx4xjo"
          className="animable"
        />
        <path
          d="M178.42,144.23a2.8,2.8,0,0,1,1.3-.21,3.59,3.59,0,0,1,1.45.28,3.42,3.42,0,0,1,.77.45,2.06,2.06,0,0,1,.57.83,1.62,1.62,0,0,1,.11,1,1.35,1.35,0,0,1-.63.76,3.7,3.7,0,0,1-1.42.44c-.83.09-1.33-.08-1.32-.14a11.44,11.44,0,0,1,1.26-.22,4.07,4.07,0,0,0,1.22-.48.92.92,0,0,0,.4-.5,1.22,1.22,0,0,0-.1-.7,1.62,1.62,0,0,0-.42-.63,4.34,4.34,0,0,0-.64-.41,3.89,3.89,0,0,0-1.27-.34C178.92,144.32,178.42,144.31,178.42,144.23Z"
          style={{
            fill: 'rgb(120, 77, 72)',
            transformOrigin: '180.5371584892273px 145.90868890285492px',
          }}
          id="els25ozikdzuc"
          className="animable"
        />
        <path
          d="M181,150.14c0-.06.38-.08,1-.35l.47-.22a2,2,0,0,0,.48-.23c.19-.16.09-.41-.35-.66a8.38,8.38,0,0,0-2.24-.82c-.6-.11-1-.11-1-.19s.39-.2,1.05-.17a5.9,5.9,0,0,1,2.48.74,2.26,2.26,0,0,1,.31.23,1,1,0,0,1,.29.37.73.73,0,0,1-.24.88,2,2,0,0,1-.62.26l-.5.15C181.39,150.34,180.93,150.23,181,150.14Z"
          style={{
            fill: 'rgb(120, 77, 72)',
            transformOrigin: '181.45505213737488px 148.87285470962524px',
          }}
          id="elab36n82zu8b"
          className="animable"
        />
        <path
          d="M182.46,144.08c0,.15-.48.22-1,.29s-1,.12-1.06,0,.38-.41,1-.49S182.47,143.94,182.46,144.08Z"
          style={{
            fill: 'rgb(120, 77, 72)',
            transformOrigin: '181.42734706401825px 144.14953184127808px',
          }}
          id="elhmu4utmb68k"
          className="animable"
        />
        <path
          d="M185.89,148.88a9.51,9.51,0,0,0-.22-4,5.93,5.93,0,0,0-.59-1.24l-.06-.1,0-.1a3.42,3.42,0,0,0,0-1.83c-.11-.44-.25-.7-.2-.73s.27.17.49.63a3.2,3.2,0,0,1,.17,2.06l0-.2a5.6,5.6,0,0,1,.67,1.34,5.82,5.82,0,0,1,.21,3C186.21,148.49,185.94,148.91,185.89,148.88Z"
          style={{
            fill: 'rgb(120, 77, 72)',
            transformOrigin: '185.63795387744904px 144.87928247451782px',
          }}
          id="el1koj4ruwpm2"
          className="animable"
        />
        <path
          d="M192.24,146.57c0,.06-.43.11-1.09,0a5.69,5.69,0,0,1-2.36-1.24,5.56,5.56,0,0,1-1.52-2.18c-.24-.65-.25-1.07-.19-1.09a11.44,11.44,0,0,0,2.06,2.88A11,11,0,0,0,192.24,146.57Z"
          style={{
            fill: 'rgb(120, 77, 72)',
            transformOrigin: '189.64456582069397px 144.3475468158722px',
          }}
          id="el2cobu718gfb"
          className="animable"
        />
        <path
          d="M194.86,145.64a1.83,1.83,0,0,1-.7-.14,11.19,11.19,0,0,1-1.78-.73,13.25,13.25,0,0,1-4.84-4.24l.21.11h-.68a15.85,15.85,0,0,1-6.66-1.77,3.48,3.48,0,0,1-1.47-1.53c-.21-.48-.15-.78-.12-.77s.06.27.3.68a3.64,3.64,0,0,0,1.47,1.3,17.54,17.54,0,0,0,6.5,1.57h.8l.08.11a14,14,0,0,0,4.58,4.21C193.93,145.26,194.88,145.56,194.86,145.64Z"
          style={{
            fill: 'rgb(120, 77, 72)',
            transformOrigin: '186.82441806793213px 141.10487270355225px',
          }}
          id="elsw6e5679ap"
          className="animable"
        />
        <path
          d="M228.43,111.4c-1.35,3.32-8.07,36.25-8.07,36.25L198.51,139s-5.52,15.24-6.27,15,29.44,13.92,34.95,11.84c4.85-1.82,5.7-9.76,5.7-9.76l10.91-54.41S231.32,104.29,228.43,111.4Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '218.01312446594238px 133.85933685302734px',
          }}
          id="el282tmrk8zc5i"
          className="animable"
        />
        <path
          d="M284.36,189.58a10.43,10.43,0,0,1-1.69.6c-.55.18-1.23.39-2,.6s-1.69.47-2.7.68c-2,.47-4.44.91-7.15,1.27a80,80,0,0,1-8.87.59,81.74,81.74,0,0,1-8.88-.47c-2.71-.32-5.14-.72-7.16-1.17-1-.2-1.91-.45-2.71-.65s-1.48-.39-2-.56a10.7,10.7,0,0,1-1.69-.58,14.28,14.28,0,0,1,1.75.38c.55.15,1.24.32,2,.48s1.7.4,2.71.57c2,.4,4.44.76,7.14,1.05a86.62,86.62,0,0,0,8.83.43,87.61,87.61,0,0,0,8.81-.55c2.7-.33,5.12-.72,7.13-1.15,1-.19,1.91-.42,2.71-.61s1.48-.35,2-.5A14.19,14.19,0,0,1,284.36,189.58Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '261.93497467041016px 191.4500606060028px',
          }}
          id="elxxnlu0li7m8"
          className="animable"
        />
        <path
          d="M273.89,123.64a12.3,12.3,0,0,1,.91,1.53c.54,1,1.29,2.5,2.15,4.37,1.73,3.73,3.9,9,6.21,14.79l5.91,14.9,1.84,4.5a10,10,0,0,1,.63,1.67,12.91,12.91,0,0,1-.82-1.59c-.49-1-1.18-2.55-2-4.43-1.63-3.77-3.75-9-6.05-14.86s-4.42-11.07-6.06-14.83c-.82-1.88-1.52-3.39-2-4.42A13,13,0,0,1,273.89,123.64Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '282.7150115966797px 144.5199966430664px',
          }}
          id="ely1eborvbxt"
          className="animable"
        />
        <path
          d="M285,106.63c0,.09-.9.25-2.26.8a14.74,14.74,0,0,0-7.95,7.8c-.58,1.35-.76,2.26-.85,2.24a6.21,6.21,0,0,1,.51-2.37,13.42,13.42,0,0,1,8.17-8A6.21,6.21,0,0,1,285,106.63Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '279.46998596191406px 112.05015754699707px',
          }}
          id="el6pf7v8lxyvq"
          className="animable"
        />
        <path
          d="M269.79,99a2.64,2.64,0,0,1-.39.41l-1.2,1.1-4.39,4c-3.7,3.44-8.71,8.28-14,13.88s-9.79,10.92-13,14.82l-3.77,4.64-1,1.26c-.24.28-.37.43-.39.41a2.71,2.71,0,0,1,.31-.48l1-1.31c.83-1.15,2.08-2.77,3.64-4.75,3.13-4,7.62-9.32,12.9-14.94s10.35-10.43,14.12-13.8c1.88-1.69,3.42-3,4.51-3.93l1.26-1A2,2,0,0,1,269.79,99Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '250.71998596191406px 119.26087951660156px',
          }}
          id="elyzoo7v5ao4q"
          className="animable"
        />
        <path
          d="M281.43,102.85a3.92,3.92,0,0,1-.5.58L279.42,105l-5.6,5.84c-4.7,5-11.12,11.86-17.94,19.74S243.16,145.84,239,151.24l-4.91,6.42-1.34,1.75a3.49,3.49,0,0,1-.5.59,4.76,4.76,0,0,1,.41-.65c.32-.45.74-1,1.26-1.81,1.1-1.56,2.73-3.79,4.79-6.52,4.1-5.47,10-12.87,16.79-20.76s13.29-14.77,18.07-19.65c2.39-2.44,4.34-4.4,5.71-5.73l1.59-1.53A3.64,3.64,0,0,1,281.43,102.85Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '256.8399887084961px 131.42499923706055px',
          }}
          id="ellncgojdv37"
          className="animable"
        />
        <path
          d="M276,128.59a3.37,3.37,0,0,1-.45.51l-1.33,1.38c-1.2,1.24-2.87,3-4.92,5.07-4.13,4.3-9.75,10.33-15.71,17.21s-11.12,13.31-14.78,18l-4.31,5.6-1.18,1.52a3,3,0,0,1-.44.51,3.53,3.53,0,0,1,.36-.57l1.1-1.58c1-1.37,2.39-3.32,4.18-5.7,3.59-4.77,8.71-11.25,14.67-18.14S264.79,139.53,269,135.3c2.1-2.12,3.82-3.82,5-5l1.4-1.32A3.49,3.49,0,0,1,276,128.59Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '254.43999481201172px 153.48999786376953px',
          }}
          id="elrouwwi63q9j"
          className="animable"
        />
        <path
          d="M239.12,190.65a9.09,9.09,0,0,1-2.1,2.25,9.26,9.26,0,0,1-2.45,1.86,9.09,9.09,0,0,1,2.1-2.25A9.26,9.26,0,0,1,239.12,190.65Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '236.84500122070312px 192.70499420166016px',
          }}
          id="elofnolbten3"
          className="animable"
        />
        <path
          d="M282.18,144a3.09,3.09,0,0,1-.39.49l-1.2,1.35-4.45,4.91c-3.76,4.13-8.93,9.86-14.58,16.26s-10.69,12.24-14.33,16.49l-4.31,5-1.19,1.35a3.25,3.25,0,0,1-.44.45,2.54,2.54,0,0,1,.36-.52l1.11-1.41c1-1.23,2.41-3,4.19-5.13,3.57-4.31,8.57-10.2,14.22-16.6s10.87-12.09,14.7-16.16c1.92-2,3.48-3.68,4.57-4.8l1.27-1.28A3.29,3.29,0,0,1,282.18,144Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '261.73497772216797px 167.15000915527344px',
          }}
          id="elp391eq0frfq"
          className="animable"
        />
        <path
          d="M286.58,161.56a10.83,10.83,0,0,1-1,1.36c-.65.85-1.62,2.07-2.84,3.55-2.44,3-5.9,7-9.9,11.29s-7.78,8-10.58,10.66c-1.39,1.32-2.54,2.37-3.35,3.08a12,12,0,0,1-1.28,1.07,9.08,9.08,0,0,1,1.14-1.22l3.24-3.19c2.72-2.7,6.45-6.47,10.45-10.75s7.49-8.27,10-11.17l3-3.45A11.78,11.78,0,0,1,286.58,161.56Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '272.10499572753906px 177.06500244140625px',
          }}
          id="elvuwhtwmgn2"
          className="animable"
        />
        <path
          d="M253.73,193.35c.08.13-.92.77-1.81,1.88a20.08,20.08,0,0,0-1.37,2.06l-.27.35.12-.37c0-.09.06-.13.09-.13s0,0,.07.13l-.15,0a4.68,4.68,0,0,1,1.1-2.34A3.78,3.78,0,0,1,253.73,193.35Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '252.00725078582764px 195.49501037597656px',
          }}
          id="elp9iecsh9vqa"
          className="animable"
        />
        <path
          d="M289.34,178.24a66.69,66.69,0,0,1-5.09,6.52,64.6,64.6,0,0,1-5.49,6.19,66.69,66.69,0,0,1,5.09-6.52A66.14,66.14,0,0,1,289.34,178.24Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '284.0500030517578px 184.59500122070312px',
          }}
          id="elo1nuhgp3vnl"
          className="animable"
        />
        <path
          d="M277.52,191.15c.11.11-1.27,1.53-2.53,3.59s-2,3.9-2.11,3.85a9.84,9.84,0,0,1,1.67-4.13A9.41,9.41,0,0,1,277.52,191.15Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '275.20308327674866px 194.87049293518066px',
          }}
          id="eli8q6twt91sn"
          className="animable"
        />
        <path
          d="M291,189a30.47,30.47,0,0,1-2.91,4.77,30.41,30.41,0,0,1-3.35,4.48,30.47,30.47,0,0,1,2.91-4.77A30.41,30.41,0,0,1,291,189Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '287.8699951171875px 193.62499237060547px',
          }}
          id="eljfk11k7lxx"
          className="animable"
        />
        <path
          d="M246.2,104a24.79,24.79,0,0,1-2.16,2.71c-1.36,1.64-3.24,3.91-5.26,6.47s-3.79,4.92-5.06,6.64a24.24,24.24,0,0,1-2.13,2.73,3.18,3.18,0,0,1,.45-.82c.31-.51.78-1.24,1.38-2.13,1.2-1.77,2.93-4.17,5-6.74s3.95-4.81,5.4-6.39c.72-.79,1.31-1.42,1.74-1.85A3.71,3.71,0,0,1,246.2,104Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '238.8949966430664px 113.2750015258789px',
          }}
          id="elmd0fe0qphy"
          className="animable"
        />
        <path
          d="M231.46,134.94a19.3,19.3,0,0,1-3.65-2.68,19.34,19.34,0,0,1-3.32-3.1,20.22,20.22,0,0,1,3.65,2.69A20,20,0,0,1,231.46,134.94Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '227.97500610351562px 132.0500030517578px',
          }}
          id="elh7u27710s18"
          className="animable"
        />
        <path
          d="M231.59,148.14c-.11.11-2-2.06-4.65-4.42s-5-4-4.91-4.15a22,22,0,0,1,5.25,3.77A21.42,21.42,0,0,1,231.59,148.14Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '226.80874681472778px 143.85700845718384px',
          }}
          id="elc0791ntyuh"
          className="animable"
        />
        <path
          d="M231.3,119.56a3.16,3.16,0,0,1,0,.67c0,.5,0,1.13,0,1.93,0,1.73.09,4.13.15,7.07.2,6,.46,14.24.75,23.32s.54,17.37.63,23.35c.05,3,.06,5.4,0,7.07,0,.79,0,1.43,0,1.93a3.5,3.5,0,0,1-.05.67,2.94,2.94,0,0,1-.06-.67c0-.5,0-1.13-.06-1.93,0-1.73-.12-4.13-.21-7.07-.2-6-.48-14.24-.78-23.33s-.53-17.36-.59-23.34c0-3,0-5.4,0-7.08,0-.83.06-1.48.08-1.92A3.92,3.92,0,0,1,231.3,119.56Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '231.97566932439804px 152.56500244140625px',
          }}
          id="elwtfvxcdoyi"
          className="animable"
        />
        <path
          d="M229.91,163.61a17.94,17.94,0,0,1-1.2-2.47c-.71-1.53-1.73-3.63-3-5.85a48.88,48.88,0,0,0-3.66-5.47,23.72,23.72,0,0,1-1.67-2.17,10,10,0,0,1,2,1.94,36,36,0,0,1,3.82,5.43,45.9,45.9,0,0,1,2.91,6A12.39,12.39,0,0,1,229.91,163.61Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '225.14500427246094px 155.62999725341797px',
          }}
          id="elwpum4mpl0wo"
          className="animable"
        />
        <path
          d="M213.85,145.27a8.76,8.76,0,0,1,.33,2.53,26.37,26.37,0,0,1-.46,6.16,27,27,0,0,1-1.87,5.88,8.63,8.63,0,0,1-1.26,2.23,49.85,49.85,0,0,0,2.62-8.21A50.16,50.16,0,0,0,213.85,145.27Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '212.39711809158325px 153.67000579833984px',
          }}
          id="elwjyzm0rg29"
          className="animable"
        />
        <path
          d="M205.18,141.57a9.9,9.9,0,0,1-.37,2.45,36,36,0,0,1-1.83,5.69,35.23,35.23,0,0,1-2.76,5.3,8.91,8.91,0,0,1-1.48,2,16.58,16.58,0,0,1,1.17-2.17,54.86,54.86,0,0,0,2.59-5.32,52.53,52.53,0,0,0,1.95-5.57A14.72,14.72,0,0,1,205.18,141.57Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '201.95999908447266px 149.29000854492188px',
          }}
          id="el5fomn87owor"
          className="animable"
        />
        <path
          d="M228.29,113.11a9.1,9.1,0,0,1,2.81,5.41,18.22,18.22,0,0,1-1.4-2.71A17.81,17.81,0,0,1,228.29,113.11Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '229.69497680664062px 115.81500244140625px',
          }}
          id="elkepfen5s13m"
          className="animable"
        />
        <path
          d="M295.6,121.42a101.24,101.24,0,0,1-10.05,2.6c-5.59,1.3-10.15,2.24-10.18,2.1a102,102,0,0,1,10.06-2.6A103.57,103.57,0,0,1,295.6,121.42Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '285.4850158691406px 123.77690362930298px',
          }}
          id="elfm01360gpyh"
          className="animable"
        />
        <path
          d="M300.62,139.67a79.8,79.8,0,0,1-8.79,2.46,79.77,79.77,0,0,1-8.91,2,78.42,78.42,0,0,1,8.79-2.47A80.43,80.43,0,0,1,300.62,139.67Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '291.7699890136719px 141.9000015258789px',
          }}
          id="el0gfovtqdtan7"
          className="animable"
        />
        <path
          d="M307.81,155.47a81.75,81.75,0,0,1-9.32,1.5,86.36,86.36,0,0,1-9.39,1,82.25,82.25,0,0,1,9.32-1.5A86.36,86.36,0,0,1,307.81,155.47Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '298.4549865722656px 156.72000122070312px',
          }}
          id="eleizmyjc71fu"
          className="animable"
        />
        <path
          d="M317.54,170.84a20.3,20.3,0,0,1-3,0c-1.86,0-4.43-.07-7.27-.06s-5.4.06-7.26.1a18.12,18.12,0,0,1-3,0,16.27,16.27,0,0,1,3-.35c1.86-.13,4.43-.24,7.28-.25s5.42.09,7.28.22A15.81,15.81,0,0,1,317.54,170.84Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '307.2749938964844px 170.61075893044472px',
          }}
          id="elxges7d4ybt"
          className="animable"
        />
        <g id="elw22sjmlb72i">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '280.3600158691406px 141.53582763671875px',
            }}
            className="animable"
          >
            <path
              d="M274.29,124.39c.69,12,4.95,24.68,12.14,34.29,0,.14-1.35-8.52-1.35-8.52s-6.52-16.27-10.79-25.77"
              id="elevwxswqe0e"
              style={{
                transformOrigin: '280.3600158691406px 141.53582763671875px',
              }}
              className="animable"
            />
          </g>
        </g>
        <g id="eljjj7cy5o9km">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '260.9509105682373px 186.33466386795044px',
            }}
            className="animable"
          >
            <path
              d="M246.47,187l21.19,1.26c3,.18,6.39.25,8.66-1.77a1,1,0,0,0,.43-.78c-.06-.6-.9-.65-1.49-.54a65.74,65.74,0,0,1-27.26-.65,3.49,3.49,0,0,0-2.07-.07c-.65.27-1.05,1.2-.56,1.7"
              id="el49lc2iwxfv7"
              style={{
                transformOrigin: '260.9509105682373px 186.33466386795044px',
              }}
              className="animable"
            />
          </g>
        </g>
        <g id="eldm787umipac">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '230.38595163822174px 141.89499282836914px',
            }}
            className="animable"
          >
            <path
              d="M232.12,159.55A55.58,55.58,0,0,1,231,124.24l1,35.21"
              id="elfq6mhqgvjlp"
              style={{
                transformOrigin: '230.38595163822174px 141.89499282836914px',
              }}
              className="animable"
            />
          </g>
        </g>
        <g id="eloc1hmrmpkw">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '222.7269287109375px 152.15029859542847px',
            }}
            className="animable"
          >
            <path
              d="M220.36,147.65a44.44,44.44,0,0,0,3.09,8.14c.21.44.57.94,1.05.85s.62-.62.59-1.07a5.37,5.37,0,0,0-1.15-2.62l-3.54-5.23"
              id="elnmeclibcyq"
              style={{
                transformOrigin: '222.7269287109375px 152.15029859542847px',
              }}
              className="animable"
            />
          </g>
        </g>
      </g>
      <g
        id="freepik--Stairs--inject-66"
        style={{ transformOrigin: '351.2649841308594px 371.3450012207031px' }}
        className="animable"
      >
        <polygon
          points="506.9 457.89 507.33 430.88 462.5 429.51 461.91 401.36 416.24 401.36 416.24 385.44 367.16 385.44 367.16 369.79 326.94 368.64 326.94 348.83 281.95 348.83 281.74 324.88 220.77 325.96 220.77 299.86 174.59 299.86 174.59 267.95 98.83 267.95 96.81 474.76 558.7 474.76 558.7 457.89 506.9 457.89"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '327.7550048828125px 371.3550109863281px',
          }}
          id="elrq2636pr1p"
          className="animable"
        />
        <path
          d="M98.83,268l1.29,0,3.82,0,14.82,0,55.83-.08h.16V268c0,9.6,0,20.36,0,31.91l-.19-.19,46.18,0H221v.22c0,8.16,0,17,0,26.1l-.23-.23,61-1.09H282v.25c.07,7.51.14,15.67.22,23.95l-.25-.25H327.2v20.07l-.25-.26,26.28.75,13.93.4h.26v15.9l-.26-.26h49.33v16.18l-.25-.25h45.9v.23c.2,9.68.39,19,.58,28.16l-.23-.23,44.84,1.39h.2v.21c-.16,9.45-.31,18.43-.45,27l-.19-.2,51.8,0h.15v.14c0,6.38,0,11.83,0,16.87l-.13-.12,34.94.06,9,0,3.07,0s-1,0-3.07,0l-9,0-34.94.06h-.12v-.13c0-5,0-10.49,0-16.87l.14.15-51.8,0h-.2v-.19q.19-12.86.41-27l.21.21-44.84-1.35h-.22v-.22c-.2-9.11-.4-18.48-.6-28.16l.24.24H416V385.44l.26.25H366.9v-15.9l.25.26-13.93-.4-26.29-.75h-.25V348.83l.26.26H281.7v-.25c-.08-8.28-.15-16.44-.21-23.94l.25.24-61,1.05h-.23V326c0-9.1,0-17.94,0-26.1l.21.21-46.18,0h-.18v-.18c0-11.55,0-22.31,0-31.91l.16.16L118.76,268l-14.82,0-3.82,0Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '352.2749786376953px 371.3450012207031px',
          }}
          id="elvq6gq5g3xm"
          className="animable"
        />
        <path
          d="M158.24,391.11s0-.09,0-.25,0-.42,0-.7c0-.65,0-1.54,0-2.69,0-2.35,0-5.72-.09-9.94l.16.17-43.49.09.26-.26h0v6.92c0,2.27,0,4.49,0,6.64l-.25-.26,31,.12,9.12.07,2.46,0H158l.23,0h-.19l-.62,0-2.41,0-9.06.07-31.21.12h-.25v-.25c0-2.15,0-4.37,0-6.64v-6.92h0l.26-.26,43.49.09h.17v.17c0,4.27-.07,7.67-.09,10,0,1.13,0,2,0,2.65l0,.67C158.26,391,158.25,391.11,158.24,391.11Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '136.45000076293945px 384.1749725341797px',
          }}
          id="elwaw8bjaf2c"
          className="animable"
        />
        <rect
          x="133.74"
          y="391.4"
          width="43.49"
          height="13.58"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '155.485px 398.19px',
          }}
          id="elmfc2a48vo0f"
          className="animable"
        />
        <rect
          x="257.17"
          y="456.73"
          width="43.49"
          height="13.58"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '278.915px 463.52000000000004px',
          }}
          id="elecpt0juva8n"
          className="animable"
        />
        <rect
          x="212.67"
          y="429.28"
          width="43.49"
          height="13.58"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '234.415px 436.07px',
          }}
          id="elx2hk4txadil"
          className="animable"
        />
        <path
          d="M281.68,456.44a.77.77,0,0,1,0-.25c0-.18,0-.42,0-.7,0-.65,0-1.54,0-2.68,0-2.36-.05-5.73-.09-9.95l.17.17-43.49.09c.11-.11-.27.26.25-.26h0v13.57l-.26-.25,31,.11,9.12.07,2.46,0h.65l.23,0-.2,0h-.62l-2.41,0-9.06.08-31.21.11h-.25v-.25c0-2.15,0-4.37,0-6.64v-6.93h0c.52-.52.15-.14.27-.26l43.49.09h.16v.17c0,4.27-.07,7.67-.09,10.05,0,1.12,0,2,0,2.64l0,.67A1.57,1.57,0,0,1,281.68,456.44Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '259.9300079345703px 449.49849557876587px',
          }}
          id="elwzxa5u66sv"
          className="animable"
        />
      </g>
      <g
        id="freepik--Plant--inject-66"
        style={{ transformOrigin: '187.7928466796875px 448.4748229980469px' }}
        className="animable"
      >
        <path
          d="M195.39,453.61a12.18,12.18,0,0,1,7.48-1.69,6.34,6.34,0,0,1,3.92,1.29,2.7,2.7,0,0,1,.41,3.73,3.64,3.64,0,0,1-2.3.84c-2,.18-4.26.05-5.74,1.42-.84.78-1.33,2-2.39,2.43a2.58,2.58,0,0,1-3-1,4.36,4.36,0,0,1-.65-3.22A5,5,0,0,1,195.39,453.61Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '200.40453958511353px 456.8188123703003px',
          }}
          id="eloc9h472giyg"
          className="animable"
        />
        <path
          d="M189.08,444c1.62,1.87,4.29.93,5.43-.43a10.28,10.28,0,0,0,1.82-4.94c.72-4,1.44-8.17.21-12a6.72,6.72,0,0,0-1.85-3.08,3.46,3.46,0,0,0-3.38-.75c-1.35.5-2.07,1.94-2.56,3.29a28.51,28.51,0,0,0-1.57,12.45,9.86,9.86,0,0,0,1.9,5.5"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '192.12625885009766px 433.8439083099365px',
          }}
          id="elpd78dge4p7"
          className="animable"
        />
        <path
          d="M185.51,447.23a7.34,7.34,0,0,0,.45-6.85,13,13,0,0,0-4.57-5.39,21.76,21.76,0,0,0-7.57-3.49,7.71,7.71,0,0,0-3.27-.22,3.41,3.41,0,0,0-2.53,1.91c-.61,1.51.29,3.17,1.21,4.51a54.36,54.36,0,0,0,5.42,6.68,12.72,12.72,0,0,0,5.61,3.89c2.22.61,4.44.28,5.43-1.32"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '177.21075057983398px 439.8766851425171px',
          }}
          id="elaucbsqkzj1h"
          className="animable"
        />
        <path
          d="M192.06,474.31a4,4,0,0,0,0-.93c0-.67,0-1.51,0-2.52a34.47,34.47,0,0,1,.19-3.71,28.35,28.35,0,0,1,.89-4.46,16.42,16.42,0,0,1,1.81-4.13,8.34,8.34,0,0,1,2.55-2.6,8,8,0,0,1,2.28-1,5.47,5.47,0,0,0,.9-.22,3.8,3.8,0,0,0-.93.08,7.31,7.31,0,0,0-2.39.88,8.31,8.31,0,0,0-2.7,2.64,15.67,15.67,0,0,0-1.88,4.22,27,27,0,0,0-.88,4.52,31.33,31.33,0,0,0-.11,3.76c0,1.06.09,1.93.13,2.52A5.5,5.5,0,0,0,192.06,474.31Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '196.2275652885437px 464.52367782592773px',
          }}
          id="elqnuxmh4wvlk"
          className="animable"
        />
        <path
          d="M192,472.37a1.66,1.66,0,0,0,0-.42c0-.32-.07-.72-.12-1.22-.11-1.05-.27-2.57-.4-4.46-.29-3.77-.38-7.85-.33-13.62.05-5.43.21-11.76.64-15.91.09-.94.18-1.79.28-2.53s.16-1.39.25-1.92.12-.89.16-1.2a1.55,1.55,0,0,0,0-.43,1.82,1.82,0,0,0-.1.41c-.07.32-.14.71-.24,1.2s-.2,1.16-.31,1.91-.23,1.59-.34,2.53a140.28,140.28,0,0,0-.86,14.79c-.05,5.78.19,11,.55,14.79.17,1.89.36,3.41.52,4.46.08.49.14.89.2,1.21A2.1,2.1,0,0,0,192,472.37Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '191.55922728776932px 451.5149841308594px',
          }}
          id="elktdta7m8t3i"
          className="animable"
        />
        <path
          d="M191.05,462.32a10.32,10.32,0,0,0-.14-1.26,34.56,34.56,0,0,0-.74-3.4,43.93,43.93,0,0,0-1.62-4.88,41.5,41.5,0,0,0-2.69-5.71,31.58,31.58,0,0,0-7.11-8.94,15.39,15.39,0,0,0-1.58-1.2c-.24-.17-.46-.33-.67-.46l-.6-.33a7.15,7.15,0,0,0-1.14-.57,34.68,34.68,0,0,1,3.81,2.76,33.66,33.66,0,0,1,7,8.92,48.76,48.76,0,0,1,2.7,5.66c.73,1.78,1.27,3.43,1.69,4.83s.67,2.55.85,3.35A6.48,6.48,0,0,0,191.05,462.32Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '182.9050064086914px 448.9449920654297px',
          }}
          id="eljaa2b7h5u9"
          className="animable"
        />
      </g>
      <g
        id="freepik--Floor--inject-66"
        style={{ transformOrigin: '350.7749938964844px 474.760009765625px' }}
        className="animable"
      >
        <path
          d="M656.67,474.76c0,.15-137,.26-305.88.26s-305.91-.11-305.91-.26,136.94-.26,305.91-.26S656.67,474.62,656.67,474.76Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '350.7749938964844px 474.760009765625px',
          }}
          id="elef6pkyh3z29"
          className="animable"
        />
      </g>
      <defs>
        <filter id="active" height="200%">
          <feMorphology
            in="SourceAlpha"
            result="DILATED"
            operator="dilate"
            radius={2}
          />
          <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />
          <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
          <feMerge>
            <feMergeNode in="OUTLINE" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <filter id="hover" height="200%">
          <feMorphology
            in="SourceAlpha"
            result="DILATED"
            operator="dilate"
            radius={2}
          />
          <feFlood floodColor="#ff0000" floodOpacity="0.5" result="PINK" />
          <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
          <feMerge>
            <feMergeNode in="OUTLINE" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
          <feColorMatrix
            type="matrix"
            values="0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
          />
        </filter>
      </defs>
    </svg>
  );
};

export default AboutUsFirst;

AboutUsFirst.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
};
